// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T17:25:42.294Z
// Property: Ascent on the Highline (ID: 6767906449166964)
// Collections: 10 amenities, 4 floorplans (live), 10 photos, 74 POIs, 1 reviews, 3 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166964",
  "property_external_id": "5hPnVy",
  "property_zillow_url": "https://www.zillow.com/apartments/aurora-co/ascent-on-the-highline/5hPnVy/",
  "property_apartments_url": "https://www.apartments.com/ascent-on-the-highline-aurora-co/kvg18g8/",
  "property_google_business_url": "https://www.google.com/maps/place/Ascent+on+the+Highline/data=!4m2!3m1!1s0x0:0xc3eafac44b0099df?sa=X&ved=2ahUKEwiYkYCd6aeSAxW4EEQIHfoQHlgQ_BJ6BAgOEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "48610051678",
  "property_crm_software": null,
  "property_pm_software": "AIM",
  "property_pm_info": "1100ASCH",
  "property_status": null,
  "property_slug": "ascent-on-the-highline",
  "property_name": "Ascent on the Highline",
  "property_website_url": "https://www.ascentonthehighline.com",
  "property_domain": "https://www.ascentonthehighline.com/",
  "property_address": "15597 E Ford Cir",
  "property_full_address": "15597 E Ford Cir, Aurora, CO 80017",
  "property_address_1": "15597 E Ford Cir",
  "property_address_2": null,
  "property_address_city": "Aurora",
  "property_address_state": "CO",
  "property_address_zip_full": null,
  "property_address_zip": "80017",
  "property_address_country": "US",
  "property_address_county": "Arapahoe County",
  "property_neighborhood_address": "Centre Pointe",
  "property_address_latitude": "39.698501",
  "property_address_longitude": "-104.8078868",
  "property_email": null,
  "property_phone": "(720) 350-4889",
  "property_call_tracking_phone": null,
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Ascent on the Highline in Aurora, CO, life is an elevated experience. Choose from one or two-bedroom floor plans and enjoy top-notch amenities, including a fitness center, indoor pool, and outdoor fire pit. Ready to embrace a vibrant lifestyle? Browse our availability or schedule a tour today!",
  "property_long_description": "Welcome to Ascent on the Highline, your ideal apartment community located in the heart of Aurora, CO. Our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle needs, providing the perfect blend of comfort and style. Each apartment features modern finishes and convenient in-unit washer and dryer units, ensuring your home is both functional and chic.\n\nAt Ascent on the Highline, we believe that a vibrant community is just as important as a beautiful living space. Dive into our exceptional amenities that enhance your living experience. Stay active and energized in our state-of-the-art fitness center or take your shot on the basketball court. For relaxation, unwind in our indoor pool or indulge in the soothing hot tub. During warmer months, bask in the sun at our outdoor pool or gather with friends at the spacious clubhouse, complete with an outdoor game area, fire pit, and BBQ grill—perfect for summer cookouts and enjoying the beautiful Colorado evenings.\n\nImagine the convenience of coming home to a community that prioritizes both fun and functionality. Whether you’re looking to relax by the pool or stay active in our fitness-focused amenities, Ascent on the Highline has something for everyone. \n\nFind your new home today — browse our availability or schedule a tour to visit our community! Your luxurious living experience awaits at Ascent on the Highline.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d5-5f93-73b7-86ef-925e32b845cd.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area.",
    "public_id": "019d02d5-5f93-73b7-86ef-925e32b845cd",
    "storage_key": "property/6767906449166964/019d02d5-5f93-73b7-86ef-925e32b845cd.webp",
    "width": 2500,
    "height": 1667
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "138",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": "56",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Dogs and cats allowed. Maximum of 2 pets per apartment.",
  "property_pet_policy_description": "Dogs and cats allowed. One-time pet fee: $200 per pet. Pet deposit: $200 per pet. Monthly pet rent: $40 per pet. Maximum of 2 pets per apartment.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://myrentalapplication.com/index/amcascentonthehighline",
  "property_resident_portal_url": "https://portal.goprisma.com/common/login?returnUrl=%2Fauth%2Flogin%3FreturnUrl%3D%252Fdashboard",
  "property_apply_now_url": "https://myrentalapplication.com/index/amcascentonthehighline",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d5-6bbe-725d-87b8-ab644b18d767.webp",
  "property_primary_logo_media": {
    "alt_text": "Ascent on the Highline logo",
    "public_id": "019d02d5-6bbe-725d-87b8-ab644b18d767",
    "storage_key": "property/6767906449166964/019d02d5-6bbe-725d-87b8-ab644b18d767.webp",
    "width": 620,
    "height": 392
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d5-75e3-7497-a732-51afef5c2139.webp",
  "property_secondary_logo_media": {
    "alt_text": "Ascent on the Highline logo",
    "public_id": "019d02d5-75e3-7497-a732-51afef5c2139",
    "storage_key": "property/6767906449166964/019d02d5-75e3-7497-a732-51afef5c2139.webp",
    "width": 620,
    "height": 391
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d5-8fad-7699-b40e-18d1063ad766.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Ascent on the Highline logo",
    "public_id": "019d02d5-8fad-7699-b40e-18d1063ad766",
    "storage_key": "property/6767906449166964/019d02d5-8fad-7699-b40e-18d1063ad766.webp",
    "width": 620,
    "height": 391
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d5-9a0a-7029-8164-29b6e3ea569b.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Ascent on the Highline logo",
    "public_id": "019d02d5-9a0a-7029-8164-29b6e3ea569b",
    "storage_key": "property/6767906449166964/019d02d5-9a0a-7029-8164-29b6e3ea569b.webp",
    "width": 620,
    "height": 392
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#38505a",
  "property_secondary_color": "#9b7a68",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "798 - 980",
  "property_sqft_min": "798",
  "property_sqft_max": "980",
  "property_price_range": "$1199 - $1509",
  "property_price_min": "1199",
  "property_price_max": "1509",
  "property_available_units": null,
  "property_facebook_url": "https://www.facebook.com/Ascentonthehighline",
  "property_instagram_url": "https://www.instagram.com/ascentonthehighline/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJswnlqI1ibIcR35kAS8T66sM",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_loc=S+Chambers+Rd%2C+Aurora%2C+CO+80017",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Ascent on the Highline",
  "property_home_romance_title": "Embrace Life and Love in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Ascent on the Highline, where modern living meets comfort in stunning Aurora, CO. Choose from stylish one- or two-bedroom floor plans, and enjoy exceptional amenities like a state-of-the-art fitness center, inviting pools, and a vibrant outdoor game area. Your peaceful escape awaits—find your perfect home today!",
  "property_home_floorplans_blurb": "Welcome to Ascent on the Highline, where modern living meets serene surroundings in Aurora, CO. Choose from our thoughtfully designed one and two-bedroom apartments, tailored to fit your lifestyle. Browse our available homes today and elevate your living experience to new heights!",
  "property_home_gallery_blurb": "Welcome to Ascent on the Highline in Aurora, CO, where luxury meets leisure. Enjoy a vibrant lifestyle with our indoor and outdoor pools, state-of-the-art fitness center, and a cozy fire pit for relaxing evenings. Picture yourself surrounded by spacious floor plans and endless amenities designed for your comfort!",
  "property_home_neighborhood_blurb": "Welcome to Ascent on the Highline, where modern living meets a vibrant community in Aurora, CO. Embrace a lifestyle enriched by nearby adventures like Wings Over the Rockies Air & Space Museum, Cherry Creek State Park, and the historic Aurora History Museum—your gateway to exploration is just outside your door!",
  "property_home_reviews_blurb": "At Ascent on the Highline in Aurora, CO, residents rave about their home, stating, \"The vibrant community atmosphere makes every day feel special.\" Join a neighborhood where comfort meets convenience. Experience the joy of living among friends—see what our residents have to say about this exceptional community!",
  "property_neighborhood_blurb": "At Ascent on the Highline, vibrant living meets rich culture in Aurora, CO. Stroll to local gems like the Wings Over the Rockies Air & Space Museum and the engaging Play Street Museum - Lowry. Enjoy nearby parks and fitness centers, all while embracing the charm of our welcoming community.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Ascent on the Highline in Aurora, CO, elevate your lifestyle with exceptional amenities. Enjoy a refreshing dip in our pools, stay active in the fitness center, or unwind at the fire pit. Choose from spacious one- and two-bedroom floor plans tailored to your needs and comfort.",
  "property_applynow_blurb": "At Ascent on the Highline in Aurora, CO, your ideal home awaits, featuring spacious one and two-bedroom floor plans. Enjoy top-tier amenities, from our refreshing indoor and outdoor pools to a vibrant clubhouse and outdoor game area. Ready to elevate your lifestyle? Lease your new home online today!",
  "property_contactus_blurb": "At Ascent on the Highline in Aurora, CO, choose from thoughtfully designed one and two-bedroom floor plans that elevate your living experience. Each spacious layout combines modern comfort with unique touches. Have questions? Our friendly leasing team is here to assist you in finding your perfect home!",
  "property_faqs_blurb": "At Ascent on the Highline in Aurora, CO, our thoughtfully designed one and two-bedroom floor plans cater to diverse lifestyles. Curious about our vibrant community? Dive into our FAQs page for insights and answers to your most pressing questions, ensuring you feel right at home from the start.",
  "property_floorplans_blurb": "At Ascent on the Highline in Aurora, CO, our thoughtfully designed one and two-bedroom floor plans cater to your unique lifestyle needs. Each layout combines comfort and style, ensuring a perfect fit for every resident. Browse our available apartment homes today and elevate your living experience!",
  "property_gallery_blurb": "At Ascent on the Highline in Aurora, CO, envision your ideal lifestyle amid stunning amenities. Choose between one or two-bedroom floor plans, unwind by the outdoor fire pit, or stay active in our fitness center and basketball court. Picture yourself relaxing in the indoor pool or making memories in the spacious clubhouse!",
  "property_interactivemap_blurb": "At Ascent on the Highline in Aurora, CO, find your ideal sanctuary with our diverse one and two-bedroom floor plans. Immerse yourself in unmatched amenities—like our inviting fitness center, indoor pool, and vibrant outdoor spaces. Use our interactive community map to discover your future home today!",
  "property_pets_blurb": "At Ascent on the Highline in Aurora, CO, your furry friends will feel right at home! With a spacious community that accommodates up to two pets, we offer an inviting atmosphere for both you and your four-legged companions. Enjoy life together with tailored amenities and scenic surroundings.",
  "property_referafriend_blurb": "At Ascent on the Highline in Aurora, CO, our thoughtfully designed one and two-bedroom apartments offer the perfect blend of comfort and style. Share the experience of vibrant living—refer a friend today! Great friends make great neighbors, and we can't wait to welcome them to our community!",
  "property_residentaccess_blurb": "Welcome to Ascent on the Highline in beautiful Aurora, CO, where modern living meets comfort. With our thoughtfully designed one and two-bedroom floor plans, you’ll feel right at home. Access your resident portal today to effortlessly manage rent payments, schedule maintenance, and enjoy a seamless living experience!",
  "property_reviews_blurb": "At Ascent on the Highline in Aurora, CO, residents rave about the “friendly community atmosphere and spacious layouts.” Experience the beauty of apartment living where comfort meets convenience. Hear directly from our residents and see why they love calling this place home—check out their glowing testimonials!",
  "property_created_at": "1767365057599",
  "property_scheduletour_blurb": "At Ascent on the Highline in Aurora, CO, your perfect home awaits! Choose from stylish one and two-bedroom floor plans designed with comfort in mind. Ready for a visit? Schedule a tour today and hear firsthand how our residents love life in this vibrant community!",
  "property_thankyou_blurb": "Thank you for reaching out to Ascent on the Highline! Nestled in vibrant Aurora, CO, our thoughtfully designed one and two-bedroom apartments offer modern living with stunning views. We're excited to connect and help you find your ideal home. Stay tuned for a member of our team to contact you soon!",
  "property_virtualtours_blurb": "Welcome to Ascent on the Highline in Aurora, CO, where spacious one- and two-bedroom apartments await your unique touch. Immerse yourself in vibrant living and serene spaces. Experience your future home today—take a virtual tour of our community and see what sets us apart!",
  "property_copyright": "2026 All Rights Reserved. Ascent on the Highline",
  "property_seo_title_home": "Ascent on the Highline |  Apartments in Aurora, CO",
  "property_seo_description_home": "Experience vibrant living at Ascent on the Highline in Aurora, CO. Enjoy spacious floor plans, modern amenities, and endless fun. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Aurora, CO Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Ascent on the Highline in Aurora, CO. Choose from stylish one and two-bedroom floor plans designed for your lifestyle.",
  "property_seo_title_amenities": "Amenities | Aurora, CO Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury at Ascent on the Highline in Aurora, CO. Enjoy our fitness center, pools, and vibrant clubhouse—where comfort meets community.",
  "property_seo_title_gallery": "Gallery | Apartments in Aurora, CO",
  "property_seo_description_gallery": "Discover life at Ascent on the Highline in Aurora, CO! Explore our vibrant photo gallery featuring modern floor plans and exceptional amenities.",
  "property_seo_title_virtualtours": "Virtual Tours | Ascent on the Highline Apartments",
  "property_seo_description_virtualtours": "Transform your living experience at Ascent on the Highline in Aurora, CO. Take a virtual tour of our stunning one and two-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Ascent on the Highline Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Ascent on the Highline! Dive into our interactive map to explore spacious one- and two-bedroom apartments in Aurora, CO!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Aurora, CO",
  "property_seo_description_neighborhood": "Uncover your new lifestyle at Ascent on the Highline in Aurora, CO. Enjoy vibrant neighborhoods, local favorites, and nearby attractions just steps away.",
  "property_seo_title_contact": "Contact Us | Ascent on the Highline",
  "property_seo_description_contact": "Elevate your living at Ascent on the Highline in Aurora, CO. From cozy one-bedrooms to spacious two-bedrooms, we’re here to answer your questions!",
  "property_seo_title_faqs": "FAQs | Apartments in Aurora, CO",
  "property_seo_description_faqs": "Find answers to your questions about living at Ascent on the Highline in Aurora, CO. Uncover details on our floor plans, amenities, and community features!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Aurora, CO",
  "property_seo_description_reviews": "Discover life at Ascent on the Highline! Residents share stories of our vibrant community, stunning amenities, and cozy homes in Aurora, CO.",
  "property_seo_title_applynow": "Apply Now | Apartments in Aurora, CO",
  "property_seo_description_applynow": "Elevate your lifestyle at Ascent on the Highline in Aurora, CO. Enjoy modern one and two-bedroom apartments with top-notch amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Ascent on the Highline",
  "property_seo_description_residentaccess": "Access your Ascent on the Highline resident portal to effortlessly pay rent, request maintenance, and stay connected in our vibrant Aurora community!",
  "property_seo_title_referafriend": "Refer A Friend | Ascent on the Highline",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Ascent on the Highline in Aurora, CO, and enjoy a vibrant community together. Start sharing today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Ascent on the Highline",
  "property_seo_description_scheduletour": "Experience the charm of Ascent on the Highline in Aurora, CO. Schedule your tour today and envision your perfect home in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Ascent on the Highline",
  "property_seo_description_privacy": "At Ascent on the Highline, your privacy matters. Discover how we protect your information while you enjoy modern living! View our privacy policy!",
  "property_seo_title_accessibility": "Website Accessibility | Ascent on the Highline",
  "property_seo_description_accessibility": "At Ascent on the Highline, we prioritize accessibility for all residents in Aurora, CO. Join us in fostering a community where everyone feels at home.",
  "property_seo_title_sitemap": "Sitemap | Ascent on the Highline",
  "property_seo_description_sitemap": "Navigate your way to luxury living at Ascent on the Highline! Check out our comprehensive sitemap to easily explore all our apartment options in Aurora, CO.",
  "property_seo_title_thankyou": "Thank You | Ascent on the Highline",
  "property_seo_description_thankyou": "Thank you for reaching out to Ascent on the Highline! We appreciate your interest and will connect soon to guide you to your perfect Aurora home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Aurora, CO",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790782477942",
  "amenities": [
    {
      "id": "ec_2415453db334e8e7d4e1ec04",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0952fe8a1be1f6c648e148b1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "external_id": "false",
      "title": "Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fce4e42614149f830a99f0fd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "external_id": "false",
      "title": "Indoor Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_308dea81b1a2913399fc1d85",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "external_id": "false",
      "title": "Hot Tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1212d003b2abb034477d5f8a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "external_id": "false",
      "title": "Outdoor Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_200a3d0a9a09ac41613fd6f8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "external_id": "false",
      "title": "Spacious Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd74d215b2a73c5d3c903d15",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "external_id": "false",
      "title": "Outdoor Game Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_207c10333654bfa8f57cebed",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "external_id": "false",
      "title": "Fire Pit",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d8f2e1e6601d1155ffe6b58",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "external_id": "false",
      "title": "BBQ Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_60732c9fb80813c96ded099d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "external_id": "false",
      "title": "In‑unit washer and dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_24483189-a5b9-465a-8d70-2075aa017e90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-7174-710b-b05d-ad03127b77f4.webp",
      "image_media": {
        "alt_text": "Aerial view of a multi-building apartment complex surrounded by trees under a clear blue sky.",
        "public_id": "019d02d4-7174-710b-b05d-ad03127b77f4",
        "storage_key": "property/6767906449166964/019d02d4-7174-710b-b05d-ad03127b77f4.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "A sprawling apartment community with several buildings, balconies, parking, and landscaped grounds among mature trees.",
      "link": "",
      "alt_text": "Aerial view of a multi-building apartment complex surrounded by trees under a clear blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166964%2F8bc83c9f16878c8e3a75dd93a5ff2db5.webp"
    },
    {
      "id": "custom_9073ac33-b9b5-490d-9984-df6c90797c0b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-708a-73e9-8406-9fc6f6ffc480.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with brick columns, balconies, and accessible parking.",
        "public_id": "019d02d4-708a-73e9-8406-9fc6f6ffc480",
        "storage_key": "property/6767906449166964/019d02d4-708a-73e9-8406-9fc6f6ffc480.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment community featuring balconies, brick accents, and visible accessible parking.",
      "link": "",
      "alt_text": "Exterior view of a multi-story apartment building with brick columns, balconies, and accessible parking.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166964%2F752e6b6d02c41da7ee9c296f51e36d76.webp"
    },
    {
      "id": "custom_f6fab4cf-2627-44ef-bd8d-2a6fa2717e4d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-624a-702b-94b8-88a294088877.webp",
      "image_media": {
        "alt_text": "Community lounge with kitchen bar, four stools, and a fireplace.",
        "public_id": "019d02d4-624a-702b-94b8-88a294088877",
        "storage_key": "property/6767906449166964/019d02d4-624a-702b-94b8-88a294088877.webp",
        "width": 2500,
        "height": 1667
      },
      "title": "Community",
      "description": "Open clubhouse lounge featuring a kitchen bar, seating, and a tiled fireplace for resident gatherings.",
      "link": "",
      "alt_text": "Community lounge with kitchen bar, four stools, and a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166964%2Fec2d14d654f16f52bb8750b267929143.jpg"
    },
    {
      "id": "custom_89ee6750-c8ba-4505-9760-0f79c7a19cd0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-5596-769b-ac23-df6725ef4910.webp",
      "image_media": {
        "alt_text": "Outdoor pool area at apartment community with lounge chairs and surrounding trees.",
        "public_id": "019d02d4-5596-769b-ac23-df6725ef4910",
        "storage_key": "property/6767906449166964/019d02d4-5596-769b-ac23-df6725ef4910.webp",
        "width": 2500,
        "height": 1667
      },
      "title": "Community",
      "description": "Outdoor pool area at a multifamily property featuring lounge chairs, shaded seating, and a sunny courtyard.",
      "link": "",
      "alt_text": "Outdoor pool area at apartment community with lounge chairs and surrounding trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166964%2F3981f89953329fa489d8d3e9944551c9.jpg"
    },
    {
      "id": "custom_32f061c6-11b9-4a8e-aa33-85d8d0bdb2ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-55c2-71a5-a6df-d3a225b33f53.webp",
      "image_media": {
        "alt_text": "Outdoor community pool area with lounge chairs, a stone fire pit, and trees.",
        "public_id": "019d02d4-55c2-71a5-a6df-d3a225b33f53",
        "storage_key": "property/6767906449166964/019d02d4-55c2-71a5-a6df-d3a225b33f53.webp",
        "width": 2500,
        "height": 1667
      },
      "title": "Community",
      "description": "Sunny outdoor pool area at a multifamily community with seating, a fire pit, and surrounding buildings.",
      "link": "",
      "alt_text": "Outdoor community pool area with lounge chairs, a stone fire pit, and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166964%2Fffc5275464f7ea645967c2942184df8c.jpg"
    },
    {
      "id": "custom_91ad320a-daa3-4c2c-b107-08c527d9de81",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-675f-73dc-8b2f-e24554135176.webp",
      "image_media": {
        "alt_text": "Kitchen in an apartment with white cabinets, black appliances, and a round wall mirror.",
        "public_id": "019d02d4-675f-73dc-8b2f-e24554135176",
        "storage_key": "property/6767906449166964/019d02d4-675f-73dc-8b2f-e24554135176.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with white cabinets, black appliances, and a bench with pillows beside a round mirror.",
      "link": "",
      "alt_text": "Kitchen in an apartment with white cabinets, black appliances, and a round wall mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166964%2F55d20fac0bb2dd2d8bdada7ea8472c4d.jpg"
    },
    {
      "id": "custom_2c0f3ebb-e802-4273-8962-6061355d0bd5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-657d-761f-9a0b-33ef6d5eb025.webp",
      "image_media": {
        "alt_text": "Bedroom in an apartment with a tufted headboard, white bedding, and two nightstands.",
        "public_id": "019d02d4-657d-761f-9a0b-33ef6d5eb025",
        "storage_key": "property/6767906449166964/019d02d4-657d-761f-9a0b-33ef6d5eb025.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with neutral tones, plush bedding, and modern nightstands.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a tufted headboard, white bedding, and two nightstands.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166964%2Fa650a6f0dfdcde53744a2b715a38eb57.jpg"
    },
    {
      "id": "custom_3d578974-4925-4e4e-8d04-3fff89a08c19",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-6453-726c-84bb-1695c3a47690.webp",
      "image_media": {
        "alt_text": "Open-concept living space in an apartment with dining area, gray sofa, and a fireplace.",
        "public_id": "019d02d4-6453-726c-84bb-1695c3a47690",
        "storage_key": "property/6767906449166964/019d02d4-6453-726c-84bb-1695c3a47690.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Open-concept apartment living area with a dining nook, gray furnishings, and a visible kitchen for a modern, cozy feel.",
      "link": "",
      "alt_text": "Open-concept living space in an apartment with dining area, gray sofa, and a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166964%2Fb68d9c497d7097f730021b84113f7bbb.jpg"
    },
    {
      "id": "custom_346ccc3e-8ea1-4b82-9127-270a8b10da75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-5594-71e6-a776-6fe445089e59.webp",
      "image_media": {
        "alt_text": "Bathroom in an apartment with a white vanity, sink, toilet, and bathtub/shower.",
        "public_id": "019d02d4-5594-71e6-a776-6fe445089e59",
        "storage_key": "property/6767906449166964/019d02d4-5594-71e6-a776-6fe445089e59.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring white cabinetry, a dark countertop, a mirror, and tidy sink area.",
      "link": "",
      "alt_text": "Bathroom in an apartment with a white vanity, sink, toilet, and bathtub/shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166964%2Fecfed164c023c20780610471ec43e9a4.jpg"
    },
    {
      "id": "custom_2e3e1185-68ec-4d8a-9218-2fbb5134b861",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-55a4-73f7-a8fd-03f92b844b61.webp",
      "image_media": {
        "alt_text": "Modern apartment bedroom with a large bed, blue accents, and matching lamps.",
        "public_id": "019d02d4-55a4-73f7-a8fd-03f92b844b61",
        "storage_key": "property/6767906449166964/019d02d4-55a4-73f7-a8fd-03f92b844b61.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Bright, contemporary bedroom in a stylish apartment featuring a plush bed, blue textiles, and matching lamps.",
      "link": "",
      "alt_text": "Modern apartment bedroom with a large bed, blue accents, and matching lamps.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166964%2F458ffa15d5ea66f3ce8bf60a7f7e9736.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_92ebd8d5-2e1b-424b-a7df-82009193204b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Cuba Bakery & Café",
      "poi_type": "Restaurants",
      "poi_address": "15028 E Mississippi Ave, Aurora, CO 80012, USA",
      "poi_short_description": "Relaxed Cuban eatery with sweet & savory pastries, cakes & espresso, plus sandwiches.",
      "poi_long_description": "Relaxed Cuban eatery with sweet & savory pastries, cakes & espresso, plus sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-ac6c-76de-ae2d-04300cbef485.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-ac6c-76de-ae2d-04300cbef485",
        "storage_key": "property/6767906449166964/019d02d3-ac6c-76de-ae2d-04300cbef485.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://cubabakeryandcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7703775998023059643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cuba-bakery--caf",
      "poi_latitude": "39.6960308",
      "poi_longitude": "-104.8126455",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 303-752-2822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af1-72da-be4a-c510648349cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af1-72da-be4a-c510648349cb",
        "storage_key": "property/6767906449166964/019d02d4-3af1-72da-be4a-c510648349cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv1ZsMJJibIcRu0hYL3RP6Wo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_bcff6b53-c88d-428c-9caf-87cd36ac88d7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "South Philly Grill",
      "poi_type": "Restaurants",
      "poi_address": "15028 E Mississippi Ave, Aurora, CO 80012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8255377809374291144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-philly-grill",
      "poi_latitude": "39.6962787",
      "poi_longitude": "-104.811947",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 303-671-6155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRZJ9N5JibIcRyKRl9mD-kHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "custom_b094b4ca-09ae-4f43-a1d1-7a092f072b83",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Kp Asian Cafe",
      "poi_type": "Restaurants",
      "poi_address": "12201 E Mississippi Ave #111, Aurora, CO 80012, USA",
      "poi_short_description": "Noodles, dumplings, and other traditional fare in a small, informal setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-ace0-757c-9916-5554f19d2e66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-ace0-757c-9916-5554f19d2e66",
        "storage_key": "property/6767906449166964/019d02d3-ace0-757c-9916-5554f19d2e66.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://kpasiancafe.menuxy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13118490434422121335&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kp-asian-cafe",
      "poi_latitude": "39.6975507",
      "poi_longitude": "-104.8465328",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 720-456-7745",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af1-72da-be4a-c510648349cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af1-72da-be4a-c510648349cb",
        "storage_key": "property/6767906449166964/019d02d4-3af1-72da-be4a-c510648349cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRbXplO99bIcRdyMXnYs9DrY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_9580868c-738c-451b-bd8a-f2fa2dda41c0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Grape Leaves Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "12405 E Mississippi Ave #200, Aurora, CO 80012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-ac93-7287-8c08-eac2376c6f42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-ac93-7287-8c08-eac2376c6f42",
        "storage_key": "property/6767906449166964/019d02d3-ac93-7287-8c08-eac2376c6f42.webp",
        "width": 856,
        "height": 615
      },
      "poi_business_url": "https://mediterraneanrestaurantaurora.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10672153409000413719&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grape-leaves-restaurant",
      "poi_latitude": "39.6969273",
      "poi_longitude": "-104.8444286",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 720-815-9367",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af1-72da-be4a-c510648349cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af1-72da-be4a-c510648349cb",
        "storage_key": "property/6767906449166964/019d02d4-3af1-72da-be4a-c510648349cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ96lGX6djbIcRF5rxY_saG5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_653f9e5e-de26-4232-8c9d-091ddcc36b2f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Senor Ric's Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "13200 E Mississippi Ave, Aurora, CO 80012, USA",
      "poi_short_description": "Circa-1986 casual Mexican restaurant serving all the traditional dishes & some gluten-free ones too.",
      "poi_long_description": "Circa-1986 casual Mexican restaurant serving all the traditional dishes & some gluten-free ones too.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-acac-769f-918c-c8fc4362461e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-acac-769f-918c-c8fc4362461e",
        "storage_key": "property/6767906449166964/019d02d3-acac-769f-918c-c8fc4362461e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.senorrics.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4115636933267448037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "senor-rics-mexican-restaurant",
      "poi_latitude": "39.69610249999999",
      "poi_longitude": "-104.8360596",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 303-750-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af1-72da-be4a-c510648349cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af1-72da-be4a-c510648349cb",
        "storage_key": "property/6767906449166964/019d02d4-3af1-72da-be4a-c510648349cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ1LDtbdibIcR5WDiN_ytHTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_2cc82570-83d8-4518-bea2-2c7b7638c37c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Waffle House",
      "poi_type": "Restaurants",
      "poi_address": "12880 E Mississippi Ave, Aurora, CO 80012, USA",
      "poi_short_description": "Simple chain spot offering American diner fare & all-day breakfast, including signature waffles.",
      "poi_long_description": "Simple chain spot offering American diner fare & all-day breakfast, including signature waffles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-b402-706b-953d-3735129647ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-b402-706b-953d-3735129647ed",
        "storage_key": "property/6767906449166964/019d02d3-b402-706b-953d-3735129647ed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.wafflehouse.com/aurora-co-1566",
      "poi_directions_map_url": "https://maps.google.com/?cid=15595710495763346792&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "waffle-house",
      "poi_latitude": "39.6961884",
      "poi_longitude": "-104.8389212",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 303-696-1566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af1-72da-be4a-c510648349cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af1-72da-be4a-c510648349cb",
        "storage_key": "property/6767906449166964/019d02d4-3af1-72da-be4a-c510648349cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_VNqErZibIcRaDXO9xAYb9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_231d2742-5b7a-462e-879c-5c8429d074a9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "IHOP",
      "poi_type": "Restaurants",
      "poi_address": "13700 E Mississippi Ave, Aurora, CO 80012, USA",
      "poi_short_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_long_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-b3c3-7408-8fc9-135dd22a29b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-b3c3-7408-8fc9-135dd22a29b9",
        "storage_key": "property/6767906449166964/019d02d3-b3c3-7408-8fc9-135dd22a29b9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://restaurants.ihop.com/en-us/co/aurora/breakfast-13700-e-mississippi-ave-1821?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=1821&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=4942025717828113804&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ihop",
      "poi_latitude": "39.6961098",
      "poi_longitude": "-104.8326479",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 303-743-7474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af1-72da-be4a-c510648349cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af1-72da-be4a-c510648349cb",
        "storage_key": "property/6767906449166964/019d02d4-3af1-72da-be4a-c510648349cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzZBrObhibIcRjFX91TSalUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_e3cbcf09-56c8-4379-a31f-4d606ff6090e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Momo Dumplings",
      "poi_type": "Restaurants",
      "poi_address": "Entrance C, 14200 E Alameda Ave #1039B, Aurora, CO 80012, USA",
      "poi_short_description": "Casual restaurant at one of the entrances to the Aurora Town Center specializing in momo dumplings and other Nepali staples.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-b42e-77b7-ad02-9705d11f64f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-b42e-77b7-ad02-9705d11f64f7",
        "storage_key": "property/6767906449166964/019d02d3-b42e-77b7-ad02-9705d11f64f7.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://momo-dumplings.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8134226244946472569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "momo-dumplings",
      "poi_latitude": "39.7082651",
      "poi_longitude": "-104.8225304",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 720-256-5377",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr7dH7RJjbIcRea6xPKyT4nA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "catering_service"
    },
    {
      "id": "custom_b2d47547-043a-46be-861a-4d25870c074a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "BJ's Restaurant & Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "14442 E Cedar Ave, Aurora, CO 80012, USA",
      "poi_short_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_long_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-b42c-76c5-a1c8-c519e4742c1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-b42c-76c5-a1c8-c519e4742c1e",
        "storage_key": "property/6767906449166964/019d02d3-b42c-76c5-a1c8-c519e4742c1e.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://www.bjsrestaurants.com/locations/co/aurora?utm_source=google&utm_medium=organic&utm_campaign=google_my_business",
      "poi_directions_map_url": "https://maps.google.com/?cid=16322687383132777362&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bjs-restaurant--brewhouse",
      "poi_latitude": "39.7124171",
      "poi_longitude": "-104.8197967",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 303-366-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af1-72da-be4a-c510648349cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af1-72da-be4a-c510648349cb",
        "storage_key": "property/6767906449166964/019d02d4-3af1-72da-be4a-c510648349cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ05thEOdibIcRkithk7HVheI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_55e9be3a-bc2c-4e62-83e5-d33a03661c98",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Red Lobster",
      "poi_type": "Restaurants",
      "poi_address": "10854 E Alameda Ave, Aurora, CO 80012, USA",
      "poi_short_description": "Casual chain eatery dishing up shrimp and lobster-focused fare in a clean environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-baae-733e-9354-42b0a0024408.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-baae-733e-9354-42b0a0024408",
        "storage_key": "property/6767906449166964/019d02d3-baae-733e-9354-42b0a0024408.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.redlobster.com/seafood-restaurants/locations/co/aurora/10854-east-alameda-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=851042992967053637&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-lobster",
      "poi_latitude": "39.710608",
      "poi_longitude": "-104.862065",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-343-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af1-72da-be4a-c510648349cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af1-72da-be4a-c510648349cb",
        "storage_key": "property/6767906449166964/019d02d4-3af1-72da-be4a-c510648349cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR-sjxyZ9bIcRRfFi1BeDzws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_4a2ad767-6c0e-490f-bb53-c665f7cb8234",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Red Robin Gourmet Burgers and Brews",
      "poi_type": "Restaurants",
      "poi_address": "1491 S Havana St, Aurora, CO 80012, USA",
      "poi_short_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_long_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-baae-733e-9354-4400d1dd9391.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-baae-733e-9354-4400d1dd9391",
        "storage_key": "property/6767906449166964/019d02d3-baae-733e-9354-4400d1dd9391.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.redrobin.com/locations/co/aurora/havana-208?store_id=208&store_type=corporate&utm_campaign=local-business-listing&utm_content=website-link&utm_medium=organic-seach&utm_source=google-business-profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=5304277221067386012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-robin-gourmet-burgers-and-brews",
      "poi_latitude": "39.6898152",
      "poi_longitude": "-104.8665013",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 303-671-7055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af1-72da-be4a-c510648349cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af1-72da-be4a-c510648349cb",
        "storage_key": "property/6767906449166964/019d02d4-3af1-72da-be4a-c510648349cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdVc2vUF9bIcRnOzqfweUnEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_895acc16-9850-430d-89eb-9af2a563252c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Thai Flavor LLC",
      "poi_type": "Restaurants",
      "poi_address": "1014 S Peoria St, Aurora, CO 80012, USA",
      "poi_short_description": "Strip-mall Thai eatery serving traditional fare like panang curry in a room with exotic touches.",
      "poi_long_description": "Strip-mall Thai eatery serving traditional fare like panang curry in a room with exotic touches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-bbaa-7033-8476-e6b8162fa862.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-bbaa-7033-8476-e6b8162fa862",
        "storage_key": "property/6767906449166964/019d02d3-bbaa-7033-8476-e6b8162fa862.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://thaiflavorrestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5357825927363993856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thai-flavor-llc",
      "poi_latitude": "39.69899420000001",
      "poi_longitude": "-104.8462943",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 720-859-7648",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af1-72da-be4a-c510648349cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af1-72da-be4a-c510648349cb",
        "storage_key": "property/6767906449166964/019d02d4-3af1-72da-be4a-c510648349cb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA1oj5jR9bIcRAKHoQEvSWko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_080788aa-58a9-40ae-93f8-26564e9bd54e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "15553 E Mississippi Ave, Aurora, CO 80017, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-bba2-7048-883f-8aac14a81d88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-bba2-7048-883f-8aac14a81d88",
        "storage_key": "property/6767906449166964/019d02d3-bba2-7048-883f-8aac14a81d88.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.7-eleven.com/locations/co/aurora/15553-e.-mississippi-21493?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17380999819996641697&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "39.6971551",
      "poi_longitude": "-104.8070229",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 303-751-5920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af4-713a-8e2d-54cfc4234b85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af4-713a-8e2d-54cfc4234b85",
        "storage_key": "property/6767906449166964/019d02d4-3af4-713a-8e2d-54cfc4234b85.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJQTUFMIxibIcRoTkHcD-3NfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_ccbe60ce-bc48-4ee6-a265-54db4c6791c7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "1200 S Buckley Rd, Aurora, CO 80017, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-c180-77f3-9c3d-930350509be9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-c180-77f3-9c3d-930350509be9",
        "storage_key": "property/6767906449166964/019d02d3-c180-77f3-9c3d-930350509be9.webp",
        "width": 744,
        "height": 419
      },
      "poi_business_url": "https://local.safeway.com/safeway/co/aurora/1200-s-buckley-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11738785019923982070&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "39.6946083",
      "poi_longitude": "-104.788971",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 303-750-6802",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af6-70be-b288-1a2b24d3f411.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af6-70be-b288-1a2b24d3f411",
        "storage_key": "property/6767906449166964/019d02d4-3af6-70be-b288-1a2b24d3f411.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU5F43GRibIcR9uY-58eK6KI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d5ebbb3a-9db1-4af2-8af2-6a9a2dcc3e55",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "15301 E Mississippi Ave, Aurora, CO 80017, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-c1f8-73fe-a54f-89b810d0c966.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-c1f8-73fe-a54f-89b810d0c966",
        "storage_key": "property/6767906449166964/019d02d3-c1f8-73fe-a54f-89b810d0c966.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-15301+e+mississippi+ave-aurora-co-80017/id=4469",
      "poi_directions_map_url": "https://maps.google.com/?cid=2019678550072372908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "39.6972647",
      "poi_longitude": "-104.8092608",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 303-751-5694",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwUZS641ibIcRrC6KyfBWBxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_445119b5-adbb-4f0d-a6cd-7dced028ca69",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "King Soopers",
      "poi_type": "Shopping & Retail",
      "poi_address": "15250 E Mississippi Ave, Aurora, CO 80012, USA",
      "poi_short_description": "Chain grocery outlet offering quality produce, meats, and household products, plus a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-c26c-72fa-9f03-76e12a53b275.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-c26c-72fa-9f03-76e12a53b275",
        "storage_key": "property/6767906449166964/019d02d3-c26c-72fa-9f03-76e12a53b275.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.kingsoopers.com/stores/grocery/co/aurora/village-green/620/00010?cid=loc_62000010_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12469940117126808889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-soopers",
      "poi_latitude": "39.6951393",
      "poi_longitude": "-104.810957",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 303-671-8697",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af6-70be-b288-1a2b24d3f411.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af6-70be-b288-1a2b24d3f411",
        "storage_key": "property/6767906449166964/019d02d4-3af6-70be-b288-1a2b24d3f411.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvf4--pFibIcROYW8y3cgDq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ed7181e7-376d-4214-9c12-0d265d40ad13",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "15240 E Iliff Ave, Aurora, CO 80014, USA",
      "poi_short_description": "Local branch of the chain of discount supermarkets featuring grocery staples as well as clothing, toys and household basics.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-c2b5-7309-bc83-35bc014a6960.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-c2b5-7309-bc83-35bc014a6960",
        "storage_key": "property/6767906449166964/019d02d3-c2b5-7309-bc83-35bc014a6960.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "https://www.walmart.com/store/4196-aurora-co/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=8417017805900269945&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "39.67345590000001",
      "poi_longitude": "-104.8112631",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 303-481-3904",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af6-70be-b288-1a2b24d3f411.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af6-70be-b288-1a2b24d3f411",
        "storage_key": "property/6767906449166964/019d02d4-3af6-70be-b288-1a2b24d3f411.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf3S1miWIbIcRecnSZBlBz3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5310df57-b4f6-4282-b225-3639d9336a37",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "14000 E Exposition Ave, Aurora, CO 80012, USA",
      "poi_short_description": "Retail chain selling products ranging from groceries, housewares and office supplies, to toys and clothing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-c79f-7408-a41c-4cfafd33fe70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-c79f-7408-a41c-4cfafd33fe70",
        "storage_key": "property/6767906449166964/019d02d3-c79f-7408-a41c-4cfafd33fe70.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1492-aurora-co/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1007264312196480084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "39.702473",
      "poi_longitude": "-104.8259881",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 303-368-1115",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-4024-75ed-a223-3cc5f3fd6e34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4024-75ed-a223-3cc5f3fd6e34",
        "storage_key": "property/6767906449166964/019d02d4-4024-75ed-a223-3cc5f3fd6e34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJm_c1B8RibIcRVDxmI46F-g0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_36776cb6-3a94-449f-938a-f00027fa1ea7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "15700 E Briarwood Cir, Aurora, CO 80016, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-c991-748a-bf6e-c590d0568ead.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-c991-748a-bf6e-c590d0568ead",
        "storage_key": "property/6767906449166964/019d02d3-c991-748a-bf6e-c590d0568ead.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/aurora-south/2458",
      "poi_directions_map_url": "https://maps.google.com/?cid=6119305719170817889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "39.5913909",
      "poi_longitude": "-104.8044329",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 720-214-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-4024-75ed-a223-3cc5f3fd6e34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4024-75ed-a223-3cc5f3fd6e34",
        "storage_key": "property/6767906449166964/019d02d4-4024-75ed-a223-3cc5f3fd6e34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJW4_8LC-PbIcRYV8xTyEk7FQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_bb8d81cf-8a79-4e80-8a0f-81c9da087e7c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "4455 S Buckley Rd, Aurora, CO 80015, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-c99c-7714-bc52-3d970f6146c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-c99c-7714-bc52-3d970f6146c2",
        "storage_key": "property/6767906449166964/019d02d3-c99c-7714-bc52-3d970f6146c2.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/CO-Aurora/1730?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1730-_-na-_-0-_-0&y_source=1_MTE4MzA0NS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=924155657845016032&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "39.635533",
      "poi_longitude": "-104.793566",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 303-627-5140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-4024-75ed-a223-3cc5f3fd6e34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4024-75ed-a223-3cc5f3fd6e34",
        "storage_key": "property/6767906449166964/019d02d4-4024-75ed-a223-3cc5f3fd6e34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn4zkjgOJbIcR4AUFp6xC0ww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_5e2fa602-33fc-48f7-bd20-1bd2478e02e9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Southlands",
      "poi_type": "Shopping & Retail",
      "poi_address": "6155 S Main St Suite 260, Aurora, CO 80016, USA",
      "poi_short_description": "Designed like a small town, this open-air mall features popular retailers, dining & a multiplex.",
      "poi_long_description": "Designed like a small town, this open-air mall features popular retailers, dining & a multiplex.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-c9f1-735b-8ad2-49e8b3ca0eab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-c9f1-735b-8ad2-49e8b3ca0eab",
        "storage_key": "property/6767906449166964/019d02d3-c9f1-735b-8ad2-49e8b3ca0eab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.shopsouthlands.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11171895621831610838&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southlands",
      "poi_latitude": "39.6045397",
      "poi_longitude": "-104.7090167",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "4 hours 0 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 303-627-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-4024-75ed-a223-3cc5f3fd6e34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4024-75ed-a223-3cc5f3fd6e34",
        "storage_key": "property/6767906449166964/019d02d4-4024-75ed-a223-3cc5f3fd6e34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZZQRVnyMbIcR1tEDd-CLCps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_ea209f67-0354-484a-ae7d-646612af6b35",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Iowa Elementary School",
      "poi_type": "Education",
      "poi_address": "16701 E Iowa Ave, Aurora, CO 80017, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-cf83-761a-9a9b-b629c279959c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-cf83-761a-9a9b-b629c279959c",
        "storage_key": "property/6767906449166964/019d02d3-cf83-761a-9a9b-b629c279959c.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://iowa.aurorak12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10638426460583800493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iowa-elementary-school",
      "poi_latitude": "39.6879503",
      "poi_longitude": "-104.7934097",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 303-751-3660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-402d-7105-ae27-f230294b6496.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-402d-7105-ae27-f230294b6496",
        "storage_key": "property/6767906449166964/019d02d4-402d-7105-ae27-f230294b6496.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGfktBHxibIcRra42SIBIo5M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c1cd0bed-4388-4f87-82ca-ef7cdce35c91",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Mrachek Middle School",
      "poi_type": "Education",
      "poi_address": "1955 S Telluride St, Aurora, CO 80013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-d032-7607-96f8-69a80b3517d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-d032-7607-96f8-69a80b3517d8",
        "storage_key": "property/6767906449166964/019d02d3-d032-7607-96f8-69a80b3517d8.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://mrachek.aurorak12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10569420442493960285&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mrachek-middle-school",
      "poi_latitude": "39.6799059",
      "poi_longitude": "-104.7823781",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 303-750-2836",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-402d-7105-ae27-f230294b6496.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-402d-7105-ae27-f230294b6496",
        "storage_key": "property/6767906449166964/019d02d4-402d-7105-ae27-f230294b6496.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb3McItmJbIcRXcCarOQfrpI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_b84fcfe1-330c-4258-9f52-bbd9916f6b2d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Gateway High School",
      "poi_type": "Education",
      "poi_address": "1300 S Sable Blvd, Aurora, CO 80012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-d0f6-744a-baea-86942a89df2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-d0f6-744a-baea-86942a89df2c",
        "storage_key": "property/6767906449166964/019d02d3-d0f6-744a-baea-86942a89df2c.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "http://gateway.aurorak12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13845733254838268197&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gateway-high-school",
      "poi_latitude": "39.6938803",
      "poi_longitude": "-104.8191991",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 303-755-7160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-402d-7105-ae27-f230294b6496.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-402d-7105-ae27-f230294b6496",
        "storage_key": "property/6767906449166964/019d02d4-402d-7105-ae27-f230294b6496.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ1SPlJZibIcRJbFylQntJcA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_38210d9d-f462-46f1-821d-d6c856c5f826",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Montessori del Mundo",
      "poi_type": "Education",
      "poi_address": "15503 E Mississippi Ave, Aurora, CO 80017, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.montessoridelmundo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4876655076194442265&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montessori-del-mundo",
      "poi_latitude": "39.6976551",
      "poi_longitude": "-104.8076924",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 720-863-8629",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-402d-7105-ae27-f230294b6496.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-402d-7105-ae27-f230294b6496",
        "storage_key": "property/6767906449166964/019d02d4-402d-7105-ae27-f230294b6496.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJX2eGlOhlbIcRGdysRPRbrUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_ace218f9-859f-4d1a-921f-bb0bef0e2add",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Highline Community Elementary School",
      "poi_type": "Education",
      "poi_address": "11000 E Exposition Ave, Aurora, CO 80012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-d0f7-772c-9ff3-84fb2c233fa2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-d0f7-772c-9ff3-84fb2c233fa2",
        "storage_key": "property/6767906449166964/019d02d3-d0f7-772c-9ff3-84fb2c233fa2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://highline.cherrycreekschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6444771197520918689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "highline-community-elementary-school",
      "poi_latitude": "39.7028526",
      "poi_longitude": "-104.8589153",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 720-747-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-402d-7105-ae27-f230294b6496.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-402d-7105-ae27-f230294b6496",
        "storage_key": "property/6767906449166964/019d02d4-402d-7105-ae27-f230294b6496.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc0st5Dp9bIcRoTjnHkJtcFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_04532ac6-c402-40f9-85ac-0431e39724c3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Christ Our Redeemer Lutheran School",
      "poi_type": "Education",
      "poi_address": "17700 E Iliff Ave, Aurora, CO 80013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://christredeemerschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7111121214838013842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christ-our-redeemer-lutheran-school",
      "poi_latitude": "39.6738365",
      "poi_longitude": "-104.7782155",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 303-337-3108",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-402d-7105-ae27-f230294b6496.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-402d-7105-ae27-f230294b6496",
        "storage_key": "property/6767906449166964/019d02d4-402d-7105-ae27-f230294b6496.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUXy6P8OJbIcRkv8pjRHHr2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_f6086517-8cc1-4a78-97a7-a3155e7418f1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Community College of Aurora​ - CentreTech Campus",
      "poi_type": "Education",
      "poi_address": "16000 E Centretech Pkwy, Aurora, CO 80011, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-d6d3-76bf-a8cd-da7c005d3ac9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-d6d3-76bf-a8cd-da7c005d3ac9",
        "storage_key": "property/6767906449166964/019d02d3-d6d3-76bf-a8cd-da7c005d3ac9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ccaurora.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10228440369385316687&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "community-college-of-aurora---centretech-campus",
      "poi_latitude": "39.7178373",
      "poi_longitude": "-104.8027665",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 303-360-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-402d-7105-ae27-f230294b6496.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-402d-7105-ae27-f230294b6496",
        "storage_key": "property/6767906449166964/019d02d4-402d-7105-ae27-f230294b6496.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgTT1RNljbIcRTyF6x1K48o0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_2a9c5a4c-5571-4059-b129-94a3a367c51e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Pickens Technical College",
      "poi_type": "Education",
      "poi_address": "500 Airport Blvd, Aurora, CO 80011, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-d79f-7271-8977-83584e1170f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-d79f-7271-8977-83584e1170f9",
        "storage_key": "property/6767906449166964/019d02d3-d79f-7271-8977-83584e1170f9.webp",
        "width": 1080,
        "height": 810
      },
      "poi_business_url": "https://www.pickenstech.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7845523191335641753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pickens-technical-college",
      "poi_latitude": "39.7236787",
      "poi_longitude": "-104.7897935",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 303-344-4910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-402d-7105-ae27-f230294b6496.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-402d-7105-ae27-f230294b6496",
        "storage_key": "property/6767906449166964/019d02d4-402d-7105-ae27-f230294b6496.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ2sjxKxjbIcRmWKmcMbl4Gw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0ea8416a-fdfb-46b0-9060-b61cc58a401e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "University of Colorado Anschutz",
      "poi_type": "Education",
      "poi_address": "13001 E 17th Pl, Aurora, CO 80045, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-d902-76aa-9fb1-d796c69e3282.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-d902-76aa-9fb1-d796c69e3282",
        "storage_key": "property/6767906449166964/019d02d3-d902-76aa-9fb1-d796c69e3282.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cuanschutz.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9364229194661812447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-colorado-anschutz",
      "poi_latitude": "39.7455133",
      "poi_longitude": "-104.8375984",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-724-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-402d-7105-ae27-f230294b6496.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-402d-7105-ae27-f230294b6496",
        "storage_key": "property/6767906449166964/019d02d4-402d-7105-ae27-f230294b6496.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGXo4rk5jbIcR39got9Zs9IE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f672a4ba-b1ca-4006-9fff-9b5127d67f9d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Bowlero Aurora",
      "poi_type": "Entertainment",
      "poi_address": "16700 E Mississippi Ave, Aurora, CO 80017, USA",
      "poi_short_description": "Entertainment center offering blacklight bowling lanes, an arcade, laser tag, and a ropes course, plus a menu of creative eats.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-d8a7-738b-ac1d-f36ac60329f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-d8a7-738b-ac1d-f36ac60329f6",
        "storage_key": "property/6767906449166964/019d02d3-d8a7-738b-ac1d-f36ac60329f6.webp",
        "width": 1080,
        "height": 810
      },
      "poi_business_url": "https://www.bowlero.com/location/bowlero-aurora?utm_source=gbp&utm_medium=organic&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=3925928960211481259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bowlero-aurora",
      "poi_latitude": "39.6953684",
      "poi_longitude": "-104.793125",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 303-695-0680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_SvahmNibIcRq_LSvpazezY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_096dde3f-864e-460f-9a9e-d3ff9c5c30c7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Aurora History Museum",
      "poi_type": "Entertainment",
      "poi_address": "15051 E Alameda Pkwy, Aurora, CO 80012, USA",
      "poi_short_description": "Free museum dedicated to the history of the city and surrounding area, with rotating exhibits and a trolley.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-de62-728d-bed8-8e55dd52cb6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-de62-728d-bed8-8e55dd52cb6d",
        "storage_key": "property/6767906449166964/019d02d3-de62-728d-bed8-8e55dd52cb6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.auroramuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2864489516409562037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aurora-history-museum",
      "poi_latitude": "39.71121300000001",
      "poi_longitude": "-104.813431",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 303-739-6660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-4087-774b-a6cc-bdffea54328e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4087-774b-a6cc-bdffea54328e",
        "storage_key": "property/6767906449166964/019d02d4-4087-774b-a6cc-bdffea54328e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJUYxadeVibIcRtSNs2Am2wCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_7c4fb267-bd93-49a4-8773-447eaf6fe4f3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "The Aurora Fox Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "9900 E Colfax Ave, Aurora, CO 80010, USA",
      "poi_short_description": "Cozy, small theater (former movie house) known for staging musicals, plays and other live performances.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-df1c-7238-8673-7ec1fa7bbb30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-df1c-7238-8673-7ec1fa7bbb30",
        "storage_key": "property/6767906449166964/019d02d3-df1c-7238-8673-7ec1fa7bbb30.webp",
        "width": 810,
        "height": 458
      },
      "poi_business_url": "https://www.aurorafoxartscenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3561868872273313218&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-aurora-fox-arts-center",
      "poi_latitude": "39.7397219",
      "poi_longitude": "-104.8725902",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 303-739-1970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJScA57pZ8bIcRwj1fJN5MbjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_9e1f1fa8-a73e-4df1-9a1a-18d38fc9e560",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Stanley Marketplace",
      "poi_type": "Entertainment",
      "poi_address": "2501 Dallas St, Aurora, CO 80010, USA",
      "poi_short_description": "Airy warehouse hangout housing multiple food vendors, along with other retailers & businesses.",
      "poi_long_description": "Airy warehouse hangout housing multiple food vendors, along with other retailers & businesses.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-dfea-75df-83ef-1c90e35ca5d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-dfea-75df-83ef-1c90e35ca5d2",
        "storage_key": "property/6767906449166964/019d02d3-dfea-75df-83ef-1c90e35ca5d2.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://www.stanleymarketplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14252177157235253225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stanley-marketplace",
      "poi_latitude": "39.752862",
      "poi_longitude": "-104.876921",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 720-990-6743",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-4024-75ed-a223-3cc5f3fd6e34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4024-75ed-a223-3cc5f3fd6e34",
        "storage_key": "property/6767906449166964/019d02d4-4024-75ed-a223-3cc5f3fd6e34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYaB0fWJ7bIcR6Z_x_JznycU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "custom_6d6b94fc-ba53-461a-8698-7e12fa67101e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "AMC DINE-IN Southlands 16",
      "poi_type": "Entertainment",
      "poi_address": "23955 E Plaza Ave, Aurora, CO 80016, USA",
      "poi_short_description": "Casual theater chain offering 3D films as well as burgers and other eats delivered to reclining seats.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-e0d5-7624-b33d-98a8a51b2223.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-e0d5-7624-b33d-98a8a51b2223",
        "storage_key": "property/6767906449166964/019d02d3-e0d5-7624-b33d-98a8a51b2223.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/denver/amc-dine-in-southlands-16?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6396731677884524136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-dine-in-southlands-16",
      "poi_latitude": "39.6066713",
      "poi_longitude": "-104.708837",
      "poi_miles_from_property": "10.7",
      "poi_walking_minutes": "4 hours 5 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 303-627-5430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-4088-77be-8f7e-40914700ff1e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4088-77be-8f7e-40914700ff1e",
        "storage_key": "property/6767906449166964/019d02d4-4088-77be-8f7e-40914700ff1e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJa2bDSXyMbIcRaKbL15HBxVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_56d59213-fa5d-4500-b8de-e1aad9c8423b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Denver Museum of Nature & Science",
      "poi_type": "Entertainment",
      "poi_address": "2001 Colorado Blvd, Denver, CO 80205, USA",
      "poi_short_description": "Movie theater chain known for presenting 3D films on a giant screen, including blockbusters.",
      "poi_long_description": "Movie theater chain known for presenting 3D films on a giant screen, including blockbusters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-e69c-72af-a980-e2bb6986bb22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-e69c-72af-a980-e2bb6986bb22",
        "storage_key": "property/6767906449166964/019d02d3-e69c-72af-a980-e2bb6986bb22.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dmns.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14789549545145786897&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denver-museum-of-nature--science",
      "poi_latitude": "39.7475261",
      "poi_longitude": "-104.9428078",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 303-370-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-4087-774b-a6cc-bdffea54328e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4087-774b-a6cc-bdffea54328e",
        "storage_key": "property/6767906449166964/019d02d4-4087-774b-a6cc-bdffea54328e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJI3SnU1F5bIcREWJ08vMIP80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_08d3f063-f222-43b5-9ff5-e77e1fc66bcc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Denver Zoo",
      "poi_type": "Entertainment",
      "poi_address": "2300 Steele St, Denver, CO 80205, USA",
      "poi_short_description": "Sprawling facility with animal exhibits, shows & demonstrations, plus venues for eating & shopping.",
      "poi_long_description": "Sprawling facility with animal exhibits, shows & demonstrations, plus venues for eating & shopping.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-e664-7722-892f-1b5bbd4f41b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-e664-7722-892f-1b5bbd4f41b1",
        "storage_key": "property/6767906449166964/019d02d3-e664-7722-892f-1b5bbd4f41b1.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://denverzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6052009770394020905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denver-zoo",
      "poi_latitude": "39.7495961",
      "poi_longitude": "-104.9508519",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 720-337-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcY8lIE55bIcRKWyHPdIO_VM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_c4942b6e-23e3-4841-896e-d3d0c0e46af1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Children's Museum of Denver at Marsico Campus",
      "poi_type": "Entertainment",
      "poi_address": "2121 Children's Museum Dr, Denver, CO 80211, USA",
      "poi_short_description": "An old fire truck, bubble-blowing lab & other interactive exhibits help kids learn by participating.",
      "poi_long_description": "An old fire truck, bubble-blowing lab & other interactive exhibits help kids learn by participating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-e718-7578-a1dc-132dec20ed27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-e718-7578-a1dc-132dec20ed27",
        "storage_key": "property/6767906449166964/019d02d3-e718-7578-a1dc-132dec20ed27.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.mychildsmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13865368703228205308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-museum-of-denver-at-marsico-campus",
      "poi_latitude": "39.7486272",
      "poi_longitude": "-105.0169778",
      "poi_miles_from_property": "13.6",
      "poi_walking_minutes": "4 hours 58 mins",
      "poi_biking_minutes": "1 hour 37 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 303-433-7444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-4087-774b-a6cc-bdffea54328e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4087-774b-a6cc-bdffea54328e",
        "storage_key": "property/6767906449166964/019d02d4-4087-774b-a6cc-bdffea54328e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJHzj7kbt4bIcR_Fi8q1-va8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_310bfb3f-447c-42d4-8011-fa3d17392eb0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Wings Over the Rockies Air & Space Museum",
      "poi_type": "Entertainment",
      "poi_address": "7711 E Academy Blvd, Denver, CO 80230, USA",
      "poi_short_description": "Wartime aircraft, WWII uniform collection & aviation art on the former site of Lowry Air Force Base.",
      "poi_long_description": "Wartime aircraft, WWII uniform collection & aviation art on the former site of Lowry Air Force Base.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-e7b3-7576-bf7d-d60b41781b3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-e7b3-7576-bf7d-d60b41781b3e",
        "storage_key": "property/6767906449166964/019d02d3-e7b3-7576-bf7d-d60b41781b3e.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://wingsmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18042612551295927622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wings-over-the-rockies-air--space-museum",
      "poi_latitude": "39.7208907",
      "poi_longitude": "-104.8955075",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 303-360-5360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-4087-774b-a6cc-bdffea54328e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4087-774b-a6cc-bdffea54328e",
        "storage_key": "property/6767906449166964/019d02d4-4087-774b-a6cc-bdffea54328e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3XERyVl8bIcRRoX_g4U8ZPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a6e41fe6-b3a0-4f24-8646-09ea5bf364fb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Fiddler's Green Amphitheatre",
      "poi_type": "Entertainment",
      "poi_address": "6350 Greenwood Plaza Blvd, Greenwood Village, CO 80111, USA",
      "poi_short_description": "Massive amphitheater with seating, grassy slopes & mountain views featuring acclaimed music artists.",
      "poi_long_description": "Massive amphitheater with seating, grassy slopes & mountain views featuring acclaimed music artists.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-ee2b-776f-bb6a-57e28c84c880.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-ee2b-776f-bb6a-57e28c84c880",
        "storage_key": "property/6767906449166964/019d02d3-ee2b-776f-bb6a-57e28c84c880.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.fiddlersgreenamp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13818850404477874076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fiddlers-green-amphitheatre",
      "poi_latitude": "39.6006062",
      "poi_longitude": "-104.8940083",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 303-220-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOZ2mWoiGbIcRnK8qOzprxr8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_55a1c1aa-35df-4ee6-93a5-6d52c338892e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "HCA HealthONE Aurora",
      "poi_type": "Health and Wellness",
      "poi_address": "1501 S Potomac St, Aurora, CO 80012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-ee56-774a-986a-6d1954a40082.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-ee56-774a-986a-6d1954a40082",
        "storage_key": "property/6767906449166964/019d02d3-ee56-774a-986a-6d1954a40082.webp",
        "width": 750,
        "height": 421
      },
      "poi_business_url": "https://www.healthonecares.com/locations/aurora?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=16829720509392487303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-healthone-aurora",
      "poi_latitude": "39.6899801",
      "poi_longitude": "-104.8321279",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 303-695-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-455d-7688-8d0e-64a49ce09903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-455d-7688-8d0e-64a49ce09903",
        "storage_key": "property/6767906449166964/019d02d4-455d-7688-8d0e-64a49ce09903.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJN50SWyNjbIcRhwNyt6Itj-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b2048cae-7f16-4938-9925-0e5c11fd4a11",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Advanced Urgent Care & Occupational Medicine",
      "poi_type": "Health and Wellness",
      "poi_address": "1250 S Buckley Rd, Aurora, CO 80017, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-ef91-77b8-b95c-39a208a19a20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-ef91-77b8-b95c-39a208a19a20",
        "storage_key": "property/6767906449166964/019d02d3-ef91-77b8-b95c-39a208a19a20.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://advurgent.com/locations/aurora/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4860204458979939857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "advanced-urgent-care--occupational-medicine",
      "poi_latitude": "39.6937052",
      "poi_longitude": "-104.7899263",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 303-558-0508",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY_nfLmVibIcREdZEeTTqckM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_5390f8af-624b-40fd-b073-fe8695b72e5e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "AFC Urgent Care Aurora City Center",
      "poi_type": "Health and Wellness",
      "poi_address": "15372 E Alameda Pkwy, Aurora, CO 80017, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-ef80-708e-9dda-c190e0349456.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-ef80-708e-9dda-c190e0349456",
        "storage_key": "property/6767906449166964/019d02d3-ef80-708e-9dda-c190e0349456.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.afcurgentcare.com/aurora-city-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9431174635571874158&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "afc-urgent-care-aurora-city-center",
      "poi_latitude": "39.7078904",
      "poi_longitude": "-104.8093946",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 303-529-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiTqvHrhjbIcRbonvz1xD4oI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_14286582-b593-4992-9d33-b9fef79ce703",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "15700 E Briarwood Cir, Aurora, CO 80016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-f613-704d-bf06-10e81883c79d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-f613-704d-bf06-10e81883c79d",
        "storage_key": "property/6767906449166964/019d02d3-f613-704d-bf06-10e81883c79d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/aurora-co-pharmacies/15700-e-briarwood-cir-aurora-co-80016/storeid=17511?WT.mc_id=LS_GOOGLE_RX_17511",
      "poi_directions_map_url": "https://maps.google.com/?cid=5879936240950555003&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "39.5913909",
      "poi_longitude": "-104.8044329",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 720-214-6001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-45a9-710c-945b-d0d510e7d0f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-45a9-710c-945b-d0d510e7d0f6",
        "storage_key": "property/6767906449166964/019d02d4-45a9-710c-945b-d0d510e7d0f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW4_8LC-PbIcRe7HNn9u6mVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_61a5d5d0-9b4b-497c-8f9a-e9279bab59d0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "15301 E Mississippi Ave, Aurora, CO 80017, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-f618-72a0-a8f6-ccd41b04b1d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-f618-72a0-a8f6-ccd41b04b1d8",
        "storage_key": "property/6767906449166964/019d02d3-f618-72a0-a8f6-ccd41b04b1d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-15301+e+mississippi+ave-aurora-co-80017/id=4469",
      "poi_directions_map_url": "https://maps.google.com/?cid=17581991350112949076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "39.697274",
      "poi_longitude": "-104.8092459",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 303-751-5694",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-45a9-710c-945b-d0d510e7d0f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-45a9-710c-945b-d0d510e7d0f6",
        "storage_key": "property/6767906449166964/019d02d4-45a9-710c-945b-d0d510e7d0f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ53n0lI1ibIcRVBN5w_rH__M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_a52d2414-f7b4-4841-90f7-03df5ab8f57c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1730 S Buckley Rd, Aurora, CO 80017, USA",
      "poi_short_description": "Relaxed gym known for its brand-name equipment and welcoming environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-f793-7604-b363-f2e86533da40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-f793-7604-b363-f2e86533da40",
        "storage_key": "property/6767906449166964/019d02d3-f793-7604-b363-f2e86533da40.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/aurora-s-buckley-rd-co?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=16246014546497548010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.6848386",
      "poi_longitude": "-104.7892912",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 720-250-9098",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-ZSFlRZjbIcR6q7QqydwdeE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b09c8e30-867b-430f-9044-fe2376ec27f2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4211 S Buckley Rd, Aurora, CO 80013, USA",
      "poi_short_description": "Chain studio for group fitness, featuring workouts mixing strength and cardio activities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d3-fefa-74c1-8037-af0f2bdc4a6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-fefa-74c1-8037-af0f2bdc4a6f",
        "storage_key": "property/6767906449166964/019d02d3-fefa-74c1-8037-af0f2bdc4a6f.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/aurora-colorado-0517?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=15040492815473083072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "39.6402504",
      "poi_longitude": "-104.7922984",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 303-645-4292",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ20XSKAeJbIcRwIIWGYeQutA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7cf69776-b444-45f5-be42-4816b4f75f80",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "CorePower Yoga - Aurora",
      "poi_type": "Health and Wellness",
      "poi_address": "18884 E Hampden Ave, Aurora, CO 80013, USA",
      "poi_short_description": "Fitness studio offering a physically intense style of yoga that's rooted in mindfulness.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-029e-75aa-b229-782bb27085e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-029e-75aa-b229-782bb27085e9",
        "storage_key": "property/6767906449166964/019d02d4-029e-75aa-b229-782bb27085e9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.corepoweryoga.com/yoga-studios/co/denver/aurora",
      "poi_directions_map_url": "https://maps.google.com/?cid=12484919918903212199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corepower-yoga---aurora",
      "poi_latitude": "39.6519315",
      "poi_longitude": "-104.7684225",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 833-448-2561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-402d-7105-ae27-f230294b6496.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-402d-7105-ae27-f230294b6496",
        "storage_key": "property/6767906449166964/019d02d4-402d-7105-ae27-f230294b6496.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWzQiypuJbIcRp7hsr4RYQ60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_b32e8615-434d-430b-bb4a-9f7e47bb1719",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Anytime Fitness, Aurora CO",
      "poi_type": "Health and Wellness",
      "poi_address": "5458 S Parker Rd, Aurora, CO 80015, USA",
      "poi_short_description": "Chain fitness center offering 24/7 access, plus group and personal training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-0188-744c-a461-f2182c548ec8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-0188-744c-a461-f2182c548ec8",
        "storage_key": "property/6767906449166964/019d02d4-0188-744c-a461-f2182c548ec8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/aurora-colorado-4692/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=4692",
      "poi_directions_map_url": "https://maps.google.com/?cid=5716294670378564012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness-aurora-co",
      "poi_latitude": "39.616274",
      "poi_longitude": "-104.8167583",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 720-828-8998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgcojXimJbIcRrHlfa7dbVE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_657fcdda-dcf6-4171-a5e6-e55a0031cdba",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Carbon Health Urgent Care Aurora - Arapahoe Crossing",
      "poi_type": "Health and Wellness",
      "poi_address": "6554 S Parker Rd #111, Aurora, CO 80016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-0428-749b-a64a-c5822589b68d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-0428-749b-a64a-c5822589b68d",
        "storage_key": "property/6767906449166964/019d02d4-0428-749b-a64a-c5822589b68d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://carbonhealth.com/locations/aurora-co-1?utm_source=gmb&utm_medium=referral&utm_campaign=aurora-co-1&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3701166395873368344&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carbon-health-urgent-care-aurora---arapahoe-crossing",
      "poi_latitude": "39.5974665",
      "poi_longitude": "-104.8030201",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 720-615-3736",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIzgYB0qPbIcRGBmlODovXTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_c5114fb9-7966-4028-a3ff-972bf9d32885",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Northrop Grumman",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17455 E Exposition Dr, Aurora, CO 80017, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-0795-72cb-8d1b-5db84565eeb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-0795-72cb-8d1b-5db84565eeb3",
        "storage_key": "property/6767906449166964/019d02d4-0795-72cb-8d1b-5db84565eeb3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.northropgrumman.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12689272307392372328&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northrop-grumman",
      "poi_latitude": "39.7055695",
      "poi_longitude": "-104.7845683",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 720-744-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Yk9jUJibIcRaN5S1O5ZGbA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_257a9b70-007d-451f-8884-2ac94fbccc28",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Rocky Ridge Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16200 E Mississippi Ave, Aurora, CO 80017, USA",
      "poi_short_description": "Relaxed area featuring basketball courts, picnic tables and a playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-0b40-7378-9f88-418f7abfdddb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-0b40-7378-9f88-418f7abfdddb",
        "storage_key": "property/6767906449166964/019d02d4-0b40-7378-9f88-418f7abfdddb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.auroragov.org/cms/One.aspx?portalId=1881221&pageId=2023973",
      "poi_directions_map_url": "https://maps.google.com/?cid=3494932097165532039&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rocky-ridge-park",
      "poi_latitude": "39.6960992",
      "poi_longitude": "-104.7999573",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-45b0-737a-9081-ceca2668a888.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-45b0-737a-9081-ceca2668a888",
        "storage_key": "property/6767906449166964/019d02d4-45b0-737a-9081-ceca2668a888.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJa7j_eWJibIcRh5uptTl-gDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_816d5d5e-22ec-4e5b-8138-db893fd6a7a0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "DeLaney Community Farm",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "170 S Chambers Rd, Aurora, CO 80017, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-0d0c-76f9-99a5-d37cba7aab61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-0d0c-76f9-99a5-d37cba7aab61",
        "storage_key": "property/6767906449166964/019d02d4-0d0c-76f9-99a5-d37cba7aab61.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6593549749249624345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "delaney-community-farm",
      "poi_latitude": "39.7141695",
      "poi_longitude": "-104.8074685",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 303-739-6666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1yrASfpibIcRGcnjFJD-gFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farm"
    },
    {
      "id": "custom_1647bdbd-2605-434b-8eca-32061cd4196a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Cherry Creek State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4201 S Parker Rd, Aurora, CO 80014, USA",
      "poi_short_description": "Large park around a reservoir with camping, water sports & many other outdoor leisure activities.",
      "poi_long_description": "Large park around a reservoir with camping, water sports & many other outdoor leisure activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-0ce1-7198-8ea7-a0105c748cdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-0ce1-7198-8ea7-a0105c748cdb",
        "storage_key": "property/6767906449166964/019d02d4-0ce1-7198-8ea7-a0105c748cdb.webp",
        "width": 500,
        "height": 333
      },
      "poi_business_url": "https://cpw.state.co.us/placestogo/parks/CherryCreek",
      "poi_directions_map_url": "https://maps.google.com/?cid=8697569306435351271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cherry-creek-state-park",
      "poi_latitude": "39.625962",
      "poi_longitude": "-104.8424778",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 303-690-1166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-45b0-737a-9081-ceca2668a888.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-45b0-737a-9081-ceca2668a888",
        "storage_key": "property/6767906449166964/019d02d4-45b0-737a-9081-ceca2668a888.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJO9N8BMGIbIcR53Jr1zP5s3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_223ec033-b38a-4ad8-a0fe-075c1dc10975",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Triple Creek Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "18000 E Colfax Ave, Aurora, CO 80011, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-10cb-7163-a5a4-015eb924ab70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-10cb-7163-a5a4-015eb924ab70",
        "storage_key": "property/6767906449166964/019d02d4-10cb-7163-a5a4-015eb924ab70.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.auroragov.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15934503967073283348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "triple-creek-trailhead",
      "poi_latitude": "39.7394498",
      "poi_longitude": "-104.7774627",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-739-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-45b0-737a-9081-ceca2668a888.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-45b0-737a-9081-ceca2668a888",
        "storage_key": "property/6767906449166964/019d02d4-45b0-737a-9081-ceca2668a888.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjfuqnj9jbIcRFK109e66It0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c033b470-3798-4d0c-9222-98252cdae598",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Bluff Lake Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11255 E M.L.K. Jr Blvd, Denver, CO 80238, USA",
      "poi_short_description": "Walk-friendly place popular for wildlife viewing, plus a scenic lake and educational events for kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-1516-72b9-bcb3-b964dba010bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-1516-72b9-bcb3-b964dba010bd",
        "storage_key": "property/6767906449166964/019d02d4-1516-72b9-bcb3-b964dba010bd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.blufflake.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14712246050935728952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bluff-lake-nature-center",
      "poi_latitude": "39.7581832",
      "poi_longitude": "-104.8567415",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 720-708-4147",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-45b0-737a-9081-ceca2668a888.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-45b0-737a-9081-ceca2668a888",
        "storage_key": "property/6767906449166964/019d02d4-45b0-737a-9081-ceca2668a888.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVVbl8bIcROOsqotVlLMw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_refuge"
    },
    {
      "id": "custom_af008c08-5720-4454-9757-5f78f2dd0fab",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Plains Conservation Center (Visitor Center)",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "21901 E Hampden Ave, Aurora, CO 80013, USA",
      "poi_short_description": "Natural area with a reconstructed prairie homestead & Cheyenne camp, hiking trails & public events.",
      "poi_long_description": "Natural area with a reconstructed prairie homestead & Cheyenne camp, hiking trails & public events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-1517-76c5-9dd9-17e34c317421.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-1517-76c5-9dd9-17e34c317421",
        "storage_key": "property/6767906449166964/019d02d4-1517-76c5-9dd9-17e34c317421.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.auroragov.org/things_to_do/parks__open_space___trails/nature___open_space/nature_centers/plains_conservation_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=2749334225572632268&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plains-conservation-center-visitor-center",
      "poi_latitude": "39.6560284",
      "poi_longitude": "-104.737023",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 303-326-8380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-45b0-737a-9081-ceca2668a888.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-45b0-737a-9081-ceca2668a888",
        "storage_key": "property/6767906449166964/019d02d4-45b0-737a-9081-ceca2668a888.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZcWNXjSKbIcRzJYUXOmYJyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_60ec7e9f-2c25-4f6e-9cf4-e91648a363d6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Morrison Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16002 E Smith Rd, Aurora, CO 80011, USA",
      "poi_short_description": "Nature preserve featuring 250 acres of woodland, riparian areas, and wildlife, with trails and an educational center.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-15a7-74f6-ad4d-ffa50449f0f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-15a7-74f6-ad4d-ffa50449f0f6",
        "storage_key": "property/6767906449166964/019d02d4-15a7-74f6-ad4d-ffa50449f0f6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.auroragov.org/things_to_do/parks__open_space___trails/nature___open_space/nature_centers/morrison_nature_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=4230549119480299339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morrison-nature-center",
      "poi_latitude": "39.7537565",
      "poi_longitude": "-104.8009141",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 303-326-8445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-45b0-737a-9081-ceca2668a888.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-45b0-737a-9081-ceca2668a888",
        "storage_key": "property/6767906449166964/019d02d4-45b0-737a-9081-ceca2668a888.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJi4wR2nhjbIcRS_92fwLutTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cfe5b078-004c-440f-85ee-38844258815d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Expo Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10955 E Exposition Ave, Aurora, CO 80012, USA",
      "poi_short_description": "Recreational green space with basketball and tennis courts, playgrounds, picnic tables, and disc golf.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-1917-7057-97e0-0da5d58b29ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-1917-7057-97e0-0da5d58b29ab",
        "storage_key": "property/6767906449166964/019d02d4-1917-7057-97e0-0da5d58b29ab.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "http://www.auroragov.org/PROS",
      "poi_directions_map_url": "https://maps.google.com/?cid=17003473025679568021&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "expo-park",
      "poi_latitude": "39.704352",
      "poi_longitude": "-104.859554",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-326-8630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-45b0-737a-9081-ceca2668a888.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-45b0-737a-9081-ceca2668a888",
        "storage_key": "property/6767906449166964/019d02d4-45b0-737a-9081-ceca2668a888.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHTcxpCV9bIcRlSyR66B4-Os",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8eabd41a-9fdb-469a-bc02-d16424ec74a0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Aurora Metro Center Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "14555 E Centrepoint Dr, Aurora, CO 80012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2514152246297574654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aurora-metro-center-station",
      "poi_latitude": "39.7089228",
      "poi_longitude": "-104.8183919",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 303-299-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-47c6-74ad-b501-3fcb78e6d582.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-47c6-74ad-b501-3fcb78e6d582",
        "storage_key": "property/6767906449166964/019d02d4-47c6-74ad-b501-3fcb78e6d582.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJR3TykehibIcR_jzRvyUQ5CI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking"
    },
    {
      "id": "custom_9fe07863-eac1-413e-ba4a-890cd6347ad5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Florida Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Aurora, CO 80012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-1d8d-748b-b3a2-10b4f8abd843.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-1d8d-748b-b3a2-10b4f8abd843",
        "storage_key": "property/6767906449166964/019d02d4-1d8d-748b-b3a2-10b4f8abd843.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10350713926922194592&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florida-station",
      "poi_latitude": "39.6900936",
      "poi_longitude": "-104.8285012",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8VGZXbtibIcRoM7i4XkfpY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_ffafa9dd-9130-498e-9fb4-0d8adcd94c3b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "2nd Ave & Abilene Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Aurora, CO 80011, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-1da0-71e3-9349-f5906e2d09e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-1da0-71e3-9349-f5906e2d09e7",
        "storage_key": "property/6767906449166964/019d02d4-1da0-71e3-9349-f5906e2d09e7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11508226275928747787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "2nd-ave--abilene-station",
      "poi_latitude": "39.719779",
      "poi_longitude": "-104.825507",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT4X_iyBjbIcRC6-MI9NutZ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_2ef4812a-011c-46ad-9dc2-3c28d2aa8981",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "13th Ave Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Aurora, CO 80011, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-1f2a-76e8-8a10-4d10214afb83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-1f2a-76e8-8a10-4d10214afb83",
        "storage_key": "property/6767906449166964/019d02d4-1f2a-76e8-8a10-4d10214afb83.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11693487283026727761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "13th-ave-station",
      "poi_latitude": "39.7349666",
      "poi_longitude": "-104.8236429",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV4YcdT5jbIcRURNbqrqcR6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_48ed7f81-e6d3-4809-87b5-27ee327764b8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Iliff Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Aurora, CO 80014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-214e-7603-bf66-388f66b14305.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-214e-7603-bf66-388f66b14305",
        "storage_key": "property/6767906449166964/019d02d4-214e-7603-bf66-388f66b14305.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13118298156611224029&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iliff-station",
      "poi_latitude": "39.673286",
      "poi_longitude": "-104.826942",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDz21zB6IbIcR3UF5cquODbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_39f57299-6127-4fe6-aa81-7365b20cb924",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Fitzsimons Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Aurora, CO 80045, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-264c-76fc-bab3-9e770c0d5f1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-264c-76fc-bab3-9e770c0d5f1f",
        "storage_key": "property/6767906449166964/019d02d4-264c-76fc-bab3-9e770c0d5f1f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10342629173815300619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fitzsimons-station",
      "poi_latitude": "39.7550027",
      "poi_longitude": "-104.8405409",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBfs-iVZjbIcRC1LanG9miI8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_4ffae8cb-88b1-4d48-99b7-cbf3201d1377",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Peoria Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "11501 E 33rd Ave, Aurora, CO 80010, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-26b4-73af-9a8d-2ce9213885db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-26b4-73af-9a8d-2ce9213885db",
        "storage_key": "property/6767906449166964/019d02d4-26b4-73af-9a8d-2ce9213885db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9872780356425079588&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peoria-station",
      "poi_latitude": "39.7674755",
      "poi_longitude": "-104.8506223",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY5MuHU57bIcRJNsrCm0pA4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_28cbeb5f-e630-48e6-8d17-d1a98f0b2fd9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "RTD - Airport Blvd/40th Ave Park-N-Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "3900 Salida St, Aurora, CO 80011, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-2791-76ca-a054-5209c187e555.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-2791-76ca-a054-5209c187e555",
        "storage_key": "property/6767906449166964/019d02d4-2791-76ca-a054-5209c187e555.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9866885771098963306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rtd---airport-blvd40th-ave-park-n-ride",
      "poi_latitude": "39.7698273",
      "poi_longitude": "-104.7855396",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 303-292-1505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-47c6-74ad-b501-3fcb78e6d582.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-47c6-74ad-b501-3fcb78e6d582",
        "storage_key": "property/6767906449166964/019d02d4-47c6-74ad-b501-3fcb78e6d582.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-2I-ynBkbIcRar218VQ47og",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking"
    },
    {
      "id": "custom_d2acd67e-2513-4e2b-892e-6ac13c585f73",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Denver International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "8500 Peña Blvd, Denver, CO 80249, USA",
      "poi_short_description": "Sprawling, 54-sq.-mile facility known for a tentlike roof meant to resemble snow-capped mountains.",
      "poi_long_description": "Sprawling, 54-sq.-mile facility known for a tentlike roof meant to resemble snow-capped mountains.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-299a-7470-898e-6f10f4747933.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-299a-7470-898e-6f10f4747933",
        "storage_key": "property/6767906449166964/019d02d4-299a-7470-898e-6f10f4747933.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flydenver.com/?utm_source=google&utm_medium=organic&utm_campaign=GBP",
      "poi_directions_map_url": "https://maps.google.com/?cid=5285039807900523626&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denver-international-airport",
      "poi_latitude": "39.8563486",
      "poi_longitude": "-104.6764061",
      "poi_miles_from_property": "19.1",
      "poi_walking_minutes": "6 hours 56 mins",
      "poi_biking_minutes": "1 hour 40 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 720-730-4359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-4b42-70cb-92cd-12adc2033d97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4b42-70cb-92cd-12adc2033d97",
        "storage_key": "property/6767906449166964/019d02d4-4b42-70cb-92cd-12adc2033d97.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_0T_mCp_bIcRapy1NbQ7WEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_62b24919-649e-475e-940e-b661dc54317b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "UCHealth University of Colorado Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12605 E 16th Ave, Aurora, CO 80045, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-2d47-7056-b0e0-5611f9364933.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-2d47-7056-b0e0-5611f9364933",
        "storage_key": "property/6767906449166964/019d02d4-2d47-7056-b0e0-5611f9364933.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://www.uchealth.org/locations/uchealth-university-of-colorado-hospital-uch/",
      "poi_directions_map_url": "https://maps.google.com/?cid=975602612854654780&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uchealth-university-of-colorado-hospital",
      "poi_latitude": "39.7421191",
      "poi_longitude": "-104.8414959",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 720-848-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-455d-7688-8d0e-64a49ce09903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-455d-7688-8d0e-64a49ce09903",
        "storage_key": "property/6767906449166964/019d02d4-455d-7688-8d0e-64a49ce09903.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJDdDNZ7N8bIcRPAclTWgJig0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e9082b09-632b-4d3c-84b3-8776ead0f75d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Children's Hospital Colorado Anschutz Medical Campus, Aurora",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13123 E 16th Ave, Aurora, CO 80045, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-2dd8-7262-9a00-2f7533392bb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-2dd8-7262-9a00-2f7533392bb6",
        "storage_key": "property/6767906449166964/019d02d4-2dd8-7262-9a00-2f7533392bb6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.childrenscolorado.org/locations/anschutz-medical-campus-aurora/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17832171354029654962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-hospital-colorado-anschutz-medical-campus-aurora",
      "poi_latitude": "39.7422495",
      "poi_longitude": "-104.8349311",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 720-777-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-455d-7688-8d0e-64a49ce09903.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-455d-7688-8d0e-64a49ce09903",
        "storage_key": "property/6767906449166964/019d02d4-455d-7688-8d0e-64a49ce09903.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJsxqmx0hjbIcRsoPVGl6ZePc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ddff1122-3de6-4f62-b2a8-132790b52919",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Rocky Mountain Regional VA Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1700 N Wheeling St, Aurora, CO 80045, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-2e61-77ca-8577-db4cf74e7082.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-2e61-77ca-8577-db4cf74e7082",
        "storage_key": "property/6767906449166964/019d02d4-2e61-77ca-8577-db4cf74e7082.webp",
        "width": 1280,
        "height": 367
      },
      "poi_business_url": "https://www.va.gov/eastern-colorado-health-care/locations/rocky-mountain-regional-va-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2236053604677622973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rocky-mountain-regional-va-medical-center",
      "poi_latitude": "39.7424419",
      "poi_longitude": "-104.8299343",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-399-8020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-4b32-71ea-b0fe-9e5d7767749f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4b32-71ea-b0fe-9e5d7767749f",
        "storage_key": "property/6767906449166964/019d02d4-4b32-71ea-b0fe-9e5d7767749f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQBArB18bIcRvZyKBegOCB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_6eed2129-9912-4f00-8be1-e34623378cf6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Buckley Space Force Base Visitor Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1140 Aspen St, Aurora, CO 80017, USA",
      "poi_short_description": "Visitor center at a military base with free admission, where people can watch F-16s take off.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-308d-771f-ada4-236c5adece24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-308d-771f-ada4-236c5adece24",
        "storage_key": "property/6767906449166964/019d02d4-308d-771f-ada4-236c5adece24.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://www.buckley.spaceforce.mil/About-Us/Newcomers/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7677097317522764386&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buckley-space-force-base-visitor-center",
      "poi_latitude": "39.6975493",
      "poi_longitude": "-104.7698059",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 720-847-9381",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVBXXfxjbIcRYnIM1VWHimo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_91cffbc4-2b0f-4333-adf5-e1b9bde89344",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Arapahoe County DHS",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14980 E Alameda Dr, Aurora, CO 80012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-34c4-740d-aa95-0bd8a804e950.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-34c4-740d-aa95-0bd8a804e950",
        "storage_key": "property/6767906449166964/019d02d4-34c4-740d-aa95-0bd8a804e950.webp",
        "width": 720,
        "height": 358
      },
      "poi_business_url": "http://www.arapahoegov.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17197779898476940412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arapahoe-county-dhs",
      "poi_latitude": "39.708547",
      "poi_longitude": "-104.8148657",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 303-636-1130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-4b32-71ea-b0fe-9e5d7767749f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-4b32-71ea-b0fe-9e5d7767749f",
        "storage_key": "property/6767906449166964/019d02d4-4b32-71ea-b0fe-9e5d7767749f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM8LyFu9ibIcRfEwSLrPJqu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_9a8750d3-3633-4984-b3e0-d2d0ee4fa606",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "custom",
      "poi_name": "Fitzsimons Innovation Community",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12635 E Montview Blvd, Aurora, CO 80045, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3561-7492-922a-49b0ac731c6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d4-3561-7492-922a-49b0ac731c6a",
        "storage_key": "property/6767906449166964/019d02d4-3561-7492-922a-49b0ac731c6a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://fitzsimonsinnovation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5892875774146127382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fitzsimons-innovation-community",
      "poi_latitude": "39.7478531",
      "poi_longitude": "-104.8409085",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 720-859-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d4-3af3-77f4-a20f-8ae40d68a23c",
        "storage_key": "property/6767906449166964/019d02d4-3af3-77f4-a20f-8ae40d68a23c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl7QOZVNjbIcRFiZ8d0uzx1E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_a9a794d5-33c0-4750-b11b-bb72a25f323c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_033fc85a-970a-4527-bef4-81c2d382e854",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_29e3c0f0-83df-4ada-a1be-f89aeef3570b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_5459534d-9a7d-4f64-a05b-b278ea16c57e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_43d5a918-7738-4550-811d-29f0062ff43b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_7785fbef9c4171e9e9558e79",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "rating": "5",
      "name": "Marcos E",
      "text": "The community is secure and welcoming, and the apartments themselves are clean, up-to-date, and well cared for. Maintenance requests are handled quickly and professionally, and the staff is consistently friendly and attentive. I would highly recommend Ascent on the Highline to anyone searching for a top-quality place to live in the area.",
      "date": "2025-08-13",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_b029fdfe808d40497b915a2f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Ascent On The Highline 1X1 Renovated.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019f482f-e2ae-714a-99e4-c71ffdb14098.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f482f-e2ae-714a-99e4-c71ffdb14098",
        "storage_key": "property/6767906449166964/019f482f-e2ae-714a-99e4-c71ffdb14098.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Ascent On The Highline 1X1 Renovated",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=naTuio8RX1U&play=1&nt=1"
    },
    {
      "id": "ec_cc4556e645ca9e5c6fcd1b63",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019f48c3-0903-768b-8cac-b222b61976ef.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f48c3-0903-768b-8cac-b222b61976ef",
        "storage_key": "property/6767906449166964/019f48c3-0903-768b-8cac-b222b61976ef.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "1BR, 1BA - 720 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=iR6wpDqH1EN&play=1&nt=1"
    },
    {
      "id": "ec_1580cc33c7369f7b89d494df",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166964/019f48c3-07f8-725d-b132-c90bba1885f4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f48c3-07f8-725d-b132-c90bba1885f4",
        "storage_key": "property/6767906449166964/019f48c3-07f8-725d-b132-c90bba1885f4.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 980 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=my8yJz7Da1v&play=1&nt=1"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019bb810-e131-726a-92c6-c592f67ad9b0",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-ascent-on-the-highline",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "page_item_url": "in-unit-washer-dryer-apartments-aurora-co",
      "search_query": "apartments with in-unit washer and dryer Aurora CO",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Washer and Dryer",
      "h2_subtitle": "Discover the convenience of having an in-unit washer and dryer in Aurora, CO. Enjoy modern living at Ascent on the Highline.",
      "page_copy": "Welcome to Ascent on the Highline, where modern living meets convenience in the heart of Aurora, CO. Our apartments offer the ultimate comfort by providing in-unit washers and dryers, ensuring that laundry day is a breeze. Skip the laundromat and enjoy the luxury of doing laundry in the comfort of your own home.\n\nOur stunning property, located in the vibrant Centre Pointe neighborhood, doesn't just stop at laundry conveniences. Dive into an array of amenities including an outdoor game area, basketball court, and a refreshing outdoor pool. Whether you're grilling by the BBQ or unwinding in the hot tub, Ascent on the Highline offers a community designed for leisure and relaxation. Experience the best of apartment living in Aurora, CO, and make life easier with an in-unit washer and dryer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Washer Dryer Apartments Aurora CO",
      "seo_description": "Find Aurora, CO apartments with in-unit washer and dryer at Ascent on the Highline. Enjoy convenience and modern living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "page_item_url": "luxury-apartments-indoor-pool-centre-pointe",
      "search_query": "luxury apartments with indoor pool in Centre Pointe",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Indoor Pool",
      "h2_subtitle": "Explore luxury living with an indoor pool in Centre Pointe. Discover the perfect home at Ascent on the Highline.",
      "page_copy": "Experience luxury living at Ascent on the Highline, nestled in the desirable Centre Pointe neighborhood. Our apartments redefine comfort and style, offering residents access to premium amenities, including an exclusive indoor pool. This luxurious feature provides a year-round swimming option, perfect for relaxation and exercise in any season.\n\nAlongside the indoor pool, Ascent on the Highline boasts a range of high-end amenities. Enjoy outdoor fun with a dedicated game area, basketball court, and BBQ grills. Relax in the soothing hot tub after a long day. Located in Aurora, CO, our community promises a refined lifestyle with every convenience. Experience exceptional living and discover why home is truly where the heart is at Ascent on the Highline.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Indoor Pool",
      "seo_description": "Discover luxury apartments with an indoor pool in Centre Pointe, Aurora at Ascent on the Highline. Enjoy premium amenities and elegant living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "page_item_url": "spa-style-hot-tub-apartments-arapahoe-county",
      "search_query": "spa-style hot tub apartments Arapahoe County",
      "category": "Amenity",
      "h1_title": "Spa-Style Hot Tub Apartments",
      "h2_subtitle": "Relax in spa-style hot tubs at Ascent on the Highline. Discover premier apartment living in Arapahoe County.",
      "page_copy": "Welcome to Ascent on the Highline, a premier apartment community located in the heart of Arapahoe County. Our residents enjoy an unparalleled lifestyle with access to spa-style hot tubs, perfect for unwinding after a busy day. Imagine dipping into the warm, soothing waters right at home, offering relaxation and rejuvenation.\n\nBeyond the luxurious hot tubs, our community provides a host of amenities designed for leisure and entertainment. Take advantage of our basketball court, outdoor game area, and sparkling outdoor pool. Nestled in the vibrant Centre Pointe neighborhood of Aurora, CO, Ascent on the Highline combines modern living with comfort and style, making it the ideal choice for anyone seeking a serene yet active lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spa-Style Hot Tub Apartments Arapahoe County",
      "seo_description": "Find spa-style hot tub apartments in Arapahoe County at Ascent on the Highline, Aurora CO. Enjoy luxury living with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "page_item_url": "outdoor-pool-apartments-near-80017",
      "search_query": "outdoor pool apartments near 80017",
      "category": "Amenity",
      "h1_title": "Outdoor Pool Apartments Near 80017",
      "h2_subtitle": "Enjoy summer vibes all year at Ascent on the Highline. Discover apartments with an outdoor pool near 80017.",
      "page_copy": "Discover the joy of living at Ascent on the Highline, where summertime never ends. Located conveniently near the 80017 area, our apartments feature an inviting outdoor pool, perfect for relaxing weekends or unwinding after a busy day. Dive into the clear waters and soak up the sun in a peaceful setting close to home.\n\nSituated in Aurora's vibrant Centre Pointe neighborhood, our community offers more than just a pool. Enjoy amenities like a basketball court, BBQ areas, and a dedicated outdoor game zone. With modern conveniences and a friendly atmosphere, Ascent on the Highline is designed to enrich your lifestyle and make every day feel like a vacation. Explore your ideal living space in Arapahoe County today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Outdoor Pool Apartments Near 80017",
      "seo_description": "Find apartments with an outdoor pool near 80017 at Ascent on the Highline. Enjoy top amenities in a prime Aurora location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-aurora-co",
      "search_query": "fitness center apartments in Aurora CO",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Aurora, CO",
      "h2_subtitle": "Stay active at Ascent on the Highline with our state-of-the-art fitness center. Discover the best apartment living in Aurora, CO.",
      "page_copy": "At Ascent on the Highline, we prioritize your well-being with our modern fitness center, designed to help you achieve your health goals without leaving home. Nestled in the vibrant community of Aurora, CO, our apartments offer the convenience of a fully equipped gym, allowing you to maintain an active lifestyle comfortably.\n\nIn addition to the fitness center, our community offers a variety of amenities like a luxurious hot tub, outdoor pool, and an engaging outdoor game area. Located in the welcoming Centre Pointe neighborhood, Ascent on the Highline provides a harmonious balance of relaxation and activity. Experience an exceptional standard of living in Arapahoe County and make your home with us today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Aurora, CO",
      "seo_description": "Discover fitness center apartments in Aurora, CO at Ascent on the Highline. Enjoy modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-aurora-co",
      "search_query": "one bedroom apartments aurora co",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Aurora, CO",
      "h2_subtitle": "Find your ideal one bedroom apartment at Ascent on the Highline. Experience comfortable living in vibrant Aurora, CO.",
      "page_copy": "Welcome to Ascent on the Highline, where you can find the perfect one bedroom apartment in the bustling city of Aurora, CO. Our thoughtfully designed floor plans maximize space and comfort, providing a cozy yet stylish home. Each apartment features modern amenities and finishes, creating a harmonious blend of convenience and luxury.\n\nLocated in the dynamic Centre Pointe neighborhood, our community offers a wealth of amenities including a refreshing outdoor pool, spa-style hot tubs, and recreational areas like a basketball court and outdoor game space. Surrounded by the best of Arapahoe County, Ascent on the Highline is the ideal place to call home, offering a welcoming environment enhanced by an array of lifestyle amenities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Aurora, CO",
      "seo_description": "Explore one bedroom apartments in Aurora, CO at Ascent on the Highline. Enjoy a vibrant lifestyle with modern amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-centre-pointe",
      "search_query": "two bedroom apartments near centre pointe aurora",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Centre Pointe",
      "h2_subtitle": "Discover spacious two bedroom apartments at Ascent on the Highline. Perfectly positioned near Centre Pointe in Aurora.",
      "page_copy": "Searching for a spacious two bedroom apartment near Centre Pointe? Look no further than Ascent on the Highline. Situated in a prime location in Aurora, our community offers expansive living spaces with modern design touches. Perfect for families or roommates, our two bedroom layouts provide comfort and privacy paired with top-notch amenities.\n\nLiving at Ascent on the Highline means enjoying community features like a sparkling outdoor pool, a well-maintained basketball court, and inviting BBQ grills. In the heart of Arapahoe County, just minutes from Centre Pointe, you'll find convenience meets style in our welcoming environment. Experience the perfect blend of location and lifestyle by making us your new home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near Centre Pointe",
      "seo_description": "Find two bedroom apartments near Centre Pointe in Aurora at Ascent on the Highline. Enjoy spacious living and an array of amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "page_item_url": "apartments-near-university-colorado-anschutz",
      "search_query": "apartments near university of colorado anschutz aurora",
      "category": "School",
      "h1_title": "Apartments Near University of Colorado Anschutz",
      "h2_subtitle": "Live close to the University of Colorado Anschutz Medical Campus. Find modern apartments at Ascent on the Highline in Aurora.",
      "page_copy": "Looking for convenient apartments near the University of Colorado Anschutz Medical Campus? Ascent on the Highline offers the ideal living solution for students and professionals alike. Our community is strategically located in Aurora, placing you just a short drive away from the campus, making daily commutes effortless and stress-free.\n\nExperience a range of amenities that enhance your lifestyle, such as a luxurious outdoor pool, a relaxing hot tub, and engaging outdoor recreational areas. Nestled in the welcoming Centre Pointe neighborhood, Ascent on the Highline provides a balance of academic convenience and an exciting living experience in Arapahoe County. Choose us as your home base in Aurora today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Colorado Anschutz",
      "seo_description": "Find apartments near the University of Colorado Anschutz Medical Campus at Ascent on the Highline. Enjoy modern amenities in a prime Aurora location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "page_item_url": "apartments-near-childrens-hospital-colorado",
      "search_query": "apartments near children's hospital colorado aurora",
      "category": "Hospital",
      "h1_title": "Apartments Near Children's Hospital Colorado",
      "h2_subtitle": "Discover convenient living at Ascent on the Highline, near Children's Hospital Colorado in Aurora.",
      "page_copy": "If you need an apartment close to Children's Hospital Colorado, Ascent on the Highline is the perfect choice. Situated in vibrant Aurora, our community provides easy access to the hospital, making it an excellent option for healthcare professionals and families alike. Our apartments offer modern living spaces that fit various lifestyle needs with ease and comfort.\n\nResidents at Ascent on the Highline enjoy a wealth of amenities, such as a relaxing outdoor pool, a hot tub, and plenty of recreational facilities including a basketball court. Positioned in the lively Centre Pointe neighborhood, and in the heart of Arapahoe County, our community blends location with an amenity-rich lifestyle, ensuring you feel at home while being close to the heart of the city's healthcare community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Children's Hospital Colorado",
      "seo_description": "Find ideal apartments near Children's Hospital Colorado at Ascent on the Highline. Experience convenient living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "page_item_url": "apartments-close-to-uchealth-university-hospital",
      "search_query": "apartments close to uchealth university hospital aurora co",
      "category": "Hospital",
      "h1_title": "Apartments Close to UCHealth University Hospital",
      "h2_subtitle": "Stay near UCHealth University Hospital with Ascent on the Highline. Our apartments offer easy access and excellent amenities in Aurora, CO.",
      "page_copy": "For those seeking apartments close to UCHealth University Hospital in Aurora, CO, Ascent on the Highline offers a convenient and comfortable living solution. Located just a short distance from the hospital, our community makes commuting straightforward, whether you're a healthcare worker or a patient seeking nearby accommodation.\n\nAt Ascent on the Highline, residents can unwind with our inviting outdoor amenities, including a pool, hot tub, and BBQ grills. In addition, we feature a basketball court and an outdoor game area for recreational enjoyment. Situated in the Centre Pointe neighborhood of Arapahoe County, our community not only provides proximity to UCHealth University Hospital but also a warm, welcoming environment perfect for both work and leisure.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to UCHealth University Hospital",
      "seo_description": "Discover apartments close to UCHealth University Hospital at Ascent on the Highline. Enjoy proximity and premium amenities in Aurora, CO.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "page_item_url": "apartments-near-aurora-sports-park",
      "search_query": "apartments near Aurora Sports Park Aurora CO",
      "category": "Park",
      "h1_title": "Apartments Near Aurora Sports Park",
      "h2_subtitle": "Find your home at Ascent on the Highline, just moments from Aurora Sports Park in Aurora, CO.",
      "page_copy": "Looking for apartments near Aurora Sports Park in Aurora, CO? Ascent on the Highline provides perfect access to a vibrant community located just a short drive away from this bustling sports hub. Enjoy the convenience of being close to the action, whether you're cheering on local teams or participating in athletic events.\n\nOur community offers a variety of modern amenities, including an outdoor pool, a hot tub for relaxation, and a basketball court for sports enthusiasts. Situated in the friendly Centre Pointe neighborhood, Ascent on the Highline is uniquely positioned in Arapahoe County to offer a harmonious blend of active lifestyle and comfortable living spaces. Choose us for premium apartment living near Aurora Sports Park today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Aurora Sports Park",
      "seo_description": "Explore apartments near Aurora Sports Park at Ascent on the Highline. Enjoy top amenities and easy access in Aurora, CO.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "page_item_url": "cherry-creek-state-park-nearby-apartments",
      "search_query": "Cherry Creek State Park nearby apartments 80017",
      "category": "Park",
      "h1_title": "Cherry Creek State Park Nearby Apartments",
      "h2_subtitle": "Live near Cherry Creek State Park at Ascent on the Highline, conveniently located in Aurora, CO 80017.",
      "page_copy": "Searching for apartments near Cherry Creek State Park in the 80017 ZIP code? Look no further than Ascent on the Highline. Our community offers seamless access to the natural beauty and outdoor adventures of Cherry Creek State Park, making it an ideal choice for nature lovers and outdoor enthusiasts.\n\nAt Ascent on the Highline, you'll find a range of amenities designed to enhance your lifestyle, including an inviting outdoor pool, hot tub, and BBQ grills. Our basketball court and outdoor game area provide options for active recreation right at home. Located in Arapahoe County's Centre Pointe neighborhood, our community is the perfect blend of proximity to outdoor experiences and the comforts of modern apartment living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cherry Creek State Park Nearby Apartments",
      "seo_description": "Discover Cherry Creek State Park nearby apartments at Ascent on the Highline, offering convenience and comfort in Aurora, CO 80017.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-near-cherry-creek-dog-area",
      "search_query": "pet-friendly apartments near Cherry Creek Dog Of​f Leash Area Arapahoe County",
      "category": "Park",
      "h1_title": "Pet-Friendly Apartments Near Cherry Creek Dog Area",
      "h2_subtitle": "Live near Cherry Creek Dog Off Leash Area with Ascent on the Highline, your pet-friendly haven in Arapahoe County.",
      "page_copy": "If you're searching for pet-friendly apartments near the Cherry Creek Dog Off Leash Area in Arapahoe County, Ascent on the Highline is your perfect match. Our community warmly welcomes pets, providing a convenient home base just a short drive from this popular dog park where your furry friends can roam freely and safely.\n\nAt Ascent on the Highline, both you and your pets will enjoy a variety of amenities, including spacious outdoor areas and a relaxing hot tub. A basketball court and BBQ grill add to the vibrant lifestyle options available here. Nestled in the Centre Pointe neighborhood of Aurora, CO, our community provides the perfect balance of pet-friendly amenities and modern living comforts, making it an ideal choice for pet owners.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments Near Cherry Creek Dog Area",
      "seo_description": "Find pet-friendly apartments near Cherry Creek Dog Off Leash Area at Ascent on the Highline, offering ideal living in Arapahoe County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "page_item_url": "apartments-near-dayton-station-aurora",
      "search_query": "apartments near Dayton Station Aurora",
      "category": "Transit",
      "h1_title": "Apartments Near Dayton Station Aurora",
      "h2_subtitle": "Experience convenient living at Ascent on the Highline, located near Dayton Station in Aurora, CO.",
      "page_copy": "For those seeking apartments near Dayton Station in Aurora, Ascent on the Highline offers an ideal location with effortless transit access. Just moments away from Dayton Station, our community ensures a seamless commute, whether you're headed downtown or exploring the greater Denver area.\n\nResidents of Ascent on the Highline enjoy a host of amenities designed for a modern lifestyle. Unwind in the hot tub after a long day, take a dip in the outdoor pool, or partake in a friendly game on the basketball court. The vibrant Centre Pointe neighborhood in Arapahoe County sets the stage for a lively yet comfortable living environment, making our community the perfect choice for those who value both convenience and comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Dayton Station Aurora",
      "seo_description": "Discover convenient living at Ascent on the Highline, offering apartments near Dayton Station in Aurora, CO.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "page_item_url": "apartments-close-to-florida-station-co",
      "search_query": "apartments close to Florida Station CO",
      "category": "Transit",
      "h1_title": "Apartments Close to Florida Station CO",
      "h2_subtitle": "Find comfort and connectivity at Ascent on the Highline, conveniently located close to Florida Station in Aurora, CO.",
      "page_copy": "Looking for apartments close to Florida Station in Colorado? Ascent on the Highline offers the perfect blend of accessibility and modern amenities. Our location near Florida Station provides easy access to public transit, making commuting around Aurora and beyond simple and efficient.\n\nAt Ascent on the Highline, you'll enjoy a variety of amenities designed to complement your lifestyle. Whether it's lounging by the outdoor pool, enjoying a game of basketball, or relaxing in the hot tub, our community has something for everyone. Nestled in the Centre Pointe neighborhood within Arapahoe County, our apartments offer a comfortable and connected living experience just minutes from Florida Station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Florida Station CO",
      "seo_description": "Discover Ascent on the Highline, offering modern apartments close to Florida Station CO, in Aurora's vibrant locale.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "page_item_url": "apartments-by-fitzsimons-station-arapahoe-county",
      "search_query": "apartments by Fitzsimons Station Arapahoe County",
      "category": "Transit",
      "h1_title": "Apartments by Fitzsimons Station Arapahoe",
      "h2_subtitle": "Discover convenient living at Ascent on the Highline, located near Fitzsimons Station in Arapahoe County.",
      "page_copy": "For those seeking apartments by Fitzsimons Station in Arapahoe County, Ascent on the Highline offers unbeatable proximity. Our community is perfectly positioned for easy access to the station, providing hassle-free commuting options to Denver and beyond, making it an ideal choice for professionals and students alike.\n\nAt Ascent on the Highline, the amenities are designed with your lifestyle in mind. Whether you enjoy a barbecue at the grill, a dip in the outdoor pool, or shooting hoops on the basketball court, there's something here for everyone. Nestled in Aurora's Centre Pointe neighborhood, our apartments offer modern living conveniences with a touch of community charm, perfectly situated just minutes from Fitzsimons Station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Fitzsimons Station Arapahoe",
      "seo_description": "Live close to Fitzsimons Station with Ascent on the Highline, offering convenient apartments in Arapahoe County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166964",
      "source": "generator",
      "page_item_url": "apartments-near-13th-ave-station-centre-pointe",
      "search_query": "apartments near 13th Ave Station Centre Pointe",
      "category": "Transit",
      "h1_title": "Apartments Near 13th Ave Station Centre Pointe",
      "h2_subtitle": "Explore stylish living at Ascent on the Highline, located close to 13th Ave Station in Centre Pointe.",
      "page_copy": "If you're searching for apartments near 13th Ave Station in the vibrant Centre Pointe area, look no further than Ascent on the Highline. Our prime location offers excellent connectivity with easy access to 13th Ave Station, ideal for seamless commuting and exploring Aurora and the Denver metro area.\n\nResidents at Ascent on the Highline benefit from a wide array of amenities. Whether you're playing a round of basketball, relaxing by the outdoor pool, or enjoying a BBQ with friends, our facilities cater to diverse lifestyles. Positioned in the heart of Centre Pointe, our community blends the charm of Arapahoe County with the convenience of city living, offering an inviting and well-connected home base near 13th Ave Station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near 13th Ave Station Centre Pointe",
      "seo_description": "Find stylish apartments near 13th Ave Station at Ascent on the Highline, located in Centre Pointe.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10891335222"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KHLR49QQ"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "1100ASCH"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "48610051678"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "ER100107678"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im5lWGtUcVkvUGRlelliUktXb1diR1E9PSIsInZhbHVlIjoiNFhTVjZuNFBOUFZQaDFtRFBRR1hOdz09IiwibWFjIjoiODIzYmIzZjQ3MDM1MTBiNzg5YTJmOTUxNzhjMzM2NmM5NmNmM2E3Y2Q0MmVhZGM4YmVmNTM1Y2M2OTM4MzU5ZiJ9"
    }
  ],
  "custom_repli_id": "10891335222",
  "custom_google_gtm_id": "GTM-KHLR49QQ",
  "custom_rollout_phase": "Phase 3",
  "custom_vibesites_theme": "Preferred",
  "custom_aim_property_code": "1100ASCH",
  "custom_hubspot_company_id": "48610051678",
  "custom_broker_license_number": "ER100107678",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im5lWGtUcVkvUGRlelliUktXb1diR1E9PSIsInZhbHVlIjoiNFhTVjZuNFBOUFZQaDFtRFBRR1hOdz09IiwibWFjIjoiODIzYmIzZjQ3MDM1MTBiNzg5YTJmOTUxNzhjMzM2NmM5NmNmM2E3Y2Q0MmVhZGM4YmVmNTM1Y2M2OTM4MzU5ZiJ9",
  "custom_audioeye_site_id": "7b5bcdc0-9e89-4c73-bad1-42bf18725fad",
  "custom_audioeye_site_hash": "43ec6500356bdf308c46e3994d3ecb2c"
};

export const generatedAt = '2026-10-05T17:25:42.294Z';
